﻿import 'flexslider';
import 'select2';
import { BindPressRelease, ResetReleasesFilters } from '../pressRelease';
import initMasonry from '../libs/masonry';
import initContentHubArchiveFilters from '../contentHubArchiveFilters';


initMasonry($);
initContentHubArchiveFilters(jQuery);

function setVideoPlayerSize() {
  var videoWidth = $('.featured-media.has-video .video').width(),
    objectWidth = videoWidth >= 700 ? 700 : '100%',
    sidePadding = videoWidth >= 700 ? (videoWidth - 700) / 2 : 0;
  $('.featured-media.has-video .video object').width(objectWidth);
  $('.featured-media.has-video .video object').css('left', sidePadding);
}

// Function to play a specific chapter. 
function playSpecificChapter(uuid, chapter) {
    var players = VidyardV4.api.getPlayersByUUID(uuid);
    var player = players[0];
    player.playChapter(chapter);
    player.play();
}

// Get chapter information and return DOM Object
function getPlayerChapterDetails(uuid) {
    // Get all players
    var players = VidyardV4.api.getPlayersByUUID(uuid);
    // Get first player
    var player = players[0];
    return player.metadata.chapters_attributes
}

// Play at specific timestamp
function playAtTimestamp(time) {
    var video = VidyardV4.players[0];
    // Play first chapter
    video.playChapter(0);
    // Seek to specific timestamp in first chapter.
    video.seek(time);
    video.play();
}

window.playSpecificChapter = playSpecificChapter;
window.getPlayerChapterDetails = getPlayerChapterDetails;
window.playAtTimestamp = playAtTimestamp;

function resetSearchFieldPlaceholder() {
  $window.width() > 667
    ? $searchField.attr('placeholder') !== $searchPlaceholderLong &&
      $searchField.attr('placeholder', $searchPlaceholderLong)
    : $searchField.attr('placeholder') !== $searchPlaceholderShort &&
      $searchField.attr('placeholder', $searchPlaceholderShort);
}

function centerHeroContent() {
  if ($('.hero').length > 0) {
    const $primaryBar = $('.primary-bar');
    $primaryBar.css('margin-bottom', '0');
    let contentHeight = $('.hero .section-intro').height();
    let heroHeight = $('section.hero').outerHeight(!0);
    let navbarHeight =
      $primaryBar.outerHeight(!0) + $('.page-navbar-top').outerHeight(!0);
    if (navbarHeight + contentHeight >= heroHeight) {
      $('section.hero').css({
        'min-height': navbarHeight + contentHeight + 80 + 'px',
        'max-height': navbarHeight + contentHeight + 80 + 'px',
      });
      $('section.hero .bg-image').css({
        'min-height': navbarHeight + contentHeight + 80 + 'px',
        'max-height': navbarHeight + contentHeight + 80 + 'px',
      });
      (heroHeight = $('section.hero').outerHeight(!0))
    }
    var marginTop =
      (heroHeight - (navbarHeight + contentHeight)) / 2 + navbarHeight;
    $('.hero .section-intro').css('margin-top', marginTop);
  }
}

function GatewayHeroContent() {
    if ($('.mck-gateway-hero').length > 0) {
        $(".mck-gateway-hero").find('.section-intro').addClass("SCSintro");
    }
    if ($('.newsroom').length > 0) {
        $(".mck-gateway-hero").addClass("newsroomhero");
    }
}

function adjustPersonalizedHeroHeight() {
  if ($('#homezone1').length > 0) {
    if ($window.width() < 920) {
      $('#homezone1').css('height', 'auto');
      var contentHeight = $('#homezone1').outerHeight(!1),
        navbarHeight =
          $('#primary-bar').outerHeight(!0) /* + $(".navbar").outerHeight(!0)*/,
        marginTop = navbarHeight,
        newHeight = contentHeight + 50;
      $('#homezone1').css('margin-top', marginTop),
        $('#homezone1').css('height', newHeight),
        $('#video-holder').css('max-height', $('#homezone1').outerHeight(!0)),
        $('#video-holder').css('min-height', $('#homezone1').outerHeight(!0));
    } else {
      $('#homezone1').removeAttr('style');
    }
  } else
    $('#video-holder').css('max-height', 550),
      $('#video-holder').css('min-height', 550);
}

function cleanFooterLinks(eventtype) {
  if ($window.width() < 765) {
    var count = $('.footer-section nav').length - 1;
    $('.footer-section nav').each(function (i) {
      $(this).find('li').length <= 1 &&
        ($(this).unbind(eventtype)),
        i == count && $(this).css('border-bottom', 'none');
    });
  }
}

// function toggleMenu(ev) {
//   if ($(this).hasClass('open') && $(ev.target)[0].href != null) {
//     window.location.href = $(ev.target)[0].href;
//   } else {
//     ($elem = $(ev.currentTarget)),
//     !$(ev.target).closest("blah").length && $window.width() < 765 && $elem.find("li").length > 1 && (ev.preventDefault(), $elem.toggleClass("open"),
//       $(".footer-section nav").not($elem).removeClass("open"));
//   }
// }

function toggleMenu(ev) {
  const $elem = $(ev.currentTarget);
  if (
    !$(ev.target).closest('a').length &&
    $window.width() < 768 &&
    $elem.find('li').length > 0
  ) {
    ev.preventDefault();
    $elem.toggleClass('open');
      $('.footer-section nav').not($elem).removeClass('open');
      $('.footer-section.first nav').addClass('open');
  }
}

function toggleAccordion(ev) {
    if ($(this).parents('.contact-us').length === 0) {
        ev.preventDefault();
        var height = 0,
            accordion = $(this).parents('.accordion');
        accordion.toggleClass('open'),
            accordion.hasClass('open') &&
            (height = 58.5 * accordion.find('.panel li').length),
            accordion.find('.panel').css('height', height);
    }
}

function clearFilters(e) {
  e && e.stopPropagation(),
    $('.filter-tag').css('display', 'none'),
    $('.reset.active').removeClass('active'),
    $('.filter-trigger').removeClass('active'),
    $('.search-filter-sets').removeClass('active'),
    $('.apply, .cancel').removeClass('active'),
    $('.apply, .cancel').prop('disabled', !0),
    $('.search-filters-container input[type="checkbox"]').removeAttr('checked'),
    $window.width() < 1025 && $('.search-filter-set').removeClass('active'),
    $('.pretty-select')
      .each(function () {
        $(this).val($(this).find('option:first-child').val());
      })
      .promise()
      .done(function () {
        $($('.pretty-select').get(0)).trigger('change');
      });
}

function reloadFeedbackIframe() {
  $('.user-feedback iframe').attr(
    'src',
    $('.user-feedback iframe').attr('src'),
  );
}

function initializeTapToCall() {
  $(document).on('click', ".ttc-phone, a[href^='tel:']", function (ev) {
    if (!mobilecheck()) return ev.preventDefault(), !1;
  });
}

function mobilecheck() {
  var check = !1;
  return ((function(aa) {
      (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(aa) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(aa.substr(0, 4))) && (check = !0);
    }
  )(navigator.userAgent || navigator.vendor || window.opera),
    check);
}

function removeFilter(e) {
  e.preventDefault(), clearFilters(e);
}

function deferIframe(method) {
  'undefined' != typeof iFrameResize
    ? method()
    : setTimeout(function () {
        deferIframe(method);
      }, 250);
}

function subscribeToFeeds() {
  $('.filters .see-more').unbind('click'),
    $(document).on('click', '.filters .see-more', function () {
      var radioId = $(this)
        .parents('.filters')
        .find('input[type=radio]:checked')
        .attr('id');
      var index = $(this)
        .parents('.filters')
        .find('input[type=radio]:checked')
        .attr('index');
      var folderid = $(this)
        .parents('.filters')
        .find('input[type=radio]:checked')
        .attr('folderid');
      var TaxId = $(this)
        .parents('.filters')
        .find('input[type=radio]:checked')
        .attr('TaxId');
      var radioType = $(this)
        .parents('.filters')
        .find('input[type=radio]:checked')
        .val();
      if (void 0 === radioId) {
        console.log($('#hdnFeedErrorMessage').val());
      } else {
        switch (radioType) {
          case 'PressRelease':
            if (folderid) {
              window.open('/rss.aspx?folderid=' + folderid);
            } else {
              if (TaxId == 0) {
                window.open('/rss.aspx');
              } else {
                var BUid = $('#ddldepartment' + index).val();
                '0' === BUid
                  ? alert($('#hdnBUErrorMessage').val())
                  : window.open('/rss.aspx?business=' + BUid);
              }
            }
            break;
          case 'Events':
            if (folderid) {
              window.open('/rss.aspx?events=yes&folderid=' + folderid);
            } else {
              window.open('/rss.aspx?events=yes');
            }
            break;
          case 'Blogs':
            if (folderid) {
              window.open('/rss.aspx?blogs=yes&blogid=' + folderid);
            } else {
              window.open('/rss.aspx?blogs=yes');
            }
            break;
          case 'ContentHubArchive':
            if (folderid) {
              window.open(
                '/rss.aspx?type=content-hub-archive&folderid=' + folderid,
              );
            } else {
              window.open('/rss.aspx?type=content-hub-archive');
            }
            break;
          default:
            window.open(
              '/rss.aspx?type=' + radioType + '&folderid=' + folderid,
            );
            break;
        }
      }
    }),
    $('input[name=rdFeedType]:radio').change(function () {
      var TaxId = $(this).attr('TaxId');
      var inx = $(this).attr('index');
      for (let index = 0; index < 10; index++) {
        $('#departments' + index).hide();
      }
      if (TaxId != 0 && $(this).prop('checked')) {
        $('#departments' + inx).show();
      }
    });
}

function ResetFilters() {
  $('#eventList').length > 0
    ? ResetEventsFilters()
    : $('#NewsList').length > 0
      ? ResetReleasesFilters()
      : $('#blogList').length > 0 && ResetBlogFilters();
}

window.ResetFilters = ResetFilters;

function ResetEventsFilters() {
  $('.filters select').unbind('change'),
    $('.pretty-select').each(function () {
      $(this).val($(this).find('option:first-child').val()),
        $(this).trigger('change');
    }),
    $('.pretty-select').select2({
      minimumResultsForSearch: 1 / 0,
    }),
    $('.filter-sets select').on('change', function () {
      var defaultFilters = !0;
      $('.pretty-select').each(function () {
        $(this).find('option:first-child').val() !== $(this).select2('val') &&
          (defaultFilters = !1);
      }),
        defaultFilters
          ? $('.reset.active').removeClass('active')
          : $('.reset').addClass('active');
    }),
    $('.filters select').change(function () {
      BindEvents($('#hdnPageSize').val(), 1);
    }),
    history.pushState('', '', '?'),
    $('#eventList').html(''),
    $('#divPagination').html(''),
    $(
      '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneRight2_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
    ).show();
  var Type = 0,
    Industry = 0,
    Business = 0,
    Month = 0,
    EventFolderId = $('#hdnEventFolderId').val(),
    resultArray = EventFolderId.split(',').map(Number);
  $.ajax({
    type: 'POST',
    url: '/webmethods.aspx/eventsbind',
    data: JSON.stringify({
      lngFolderID: resultArray,
      lngType: Type,
      lngBusiness: Business,
      lngIndustry: Industry,
      strMonth: Month,
      intSize: 20,
      intPage: 1,
    }),
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (response) {
      $(
        '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneRight2_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
      ).hide();
      try {
        var text = response.d,
          splitText = text.split("<div id='divPagination'/>");
        $('#eventList').html(splitText[0]),
          $('#divPagination').html(splitText[1]),
          SetPushState({
            type: Type,
            business: Business,
            industry: Industry,
            month: Month,
          });
      } catch (ex) {}
    },
    failure: function (response) {
      $(
        '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneRight2_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
      ).hide(),
        alert(response);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      var errMessage =
        'An error occured serving your request. Please try again.';
      jqXHR && (errMessage = $.parseJSON(jqXHR.responseText).Message),
        $(
          '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneRight2_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
        ).hide(),
        alert(errMessage);
    },
  });
}

function ResetBlogFilters() {
  $('.filters select').unbind('change'),
    $('.pretty-select').each(function () {
      $(this).val($(this).find('option:first-child').val()),
        $(this).trigger('change');
    }),
    $('.pretty-select').select2({
      minimumResultsForSearch: 1 / 0,
    }),
    $('.filter-sets select').on('change', function () {
      var defaultFilters = !0;
      $('.pretty-select').each(function () {
        $(this).find('option:first-child').val() !== $(this).select2('val') &&
          (defaultFilters = !1);
      }),
        defaultFilters
          ? $('.reset.active').removeClass('active')
          : $('.reset').addClass('active');
    }),
    $('.filters select').change(function () {
      BindBlogArchive($('#hdnPageSize').val(), 1);
    }),
    history.pushState('', '', '?'),
    $('#blogList').html(''),
    $('#divPagination').html(''),
    $(
      '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneMain_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
    ).show();
  var Topic = 0,
    Author = 0,
    Segment = 0,
    Month = 0,
    Taxonomy = 0,
    BlogFolderId = $('#hdnBlogFolderId').val(),
    resultArray = BlogFolderId.split(',').map(Number),
    PageID = $('#hdnPageID').val();
  $.ajax({
    type: 'POST',
    url: '/webmethods.aspx/blogarchivesbind',
    data: JSON.stringify({
      lngBlogFolderId: resultArray,
      lngTopic: Topic,
      lngAuthor: Author,
      lngSegment: Segment,
      lngTaxonomy: Taxonomy,
      strMonth: Month,
      intSize: 20,
      intPage: 1,
      lngPageId: PageID,
    }),
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (response) {
      $(
        '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneMain_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
      ).hide();
      try {
        var text = response.d,
          splitText = text.split("<div id='divPagination'/>");
        $('#blogList').html(splitText[0]),
          $('#divPagination').html(splitText[1]),
          SetPushState({
            topic: Topic,
            author: Author,
            segment: Segment,
            month: Month,
            taxonomy: Taxonomy,
          }),
          $('html, body').animate(
            {
              scrollTop: 0,
            },
            0,
          );
      } catch (ex) {}
    },
    failure: function (response) {
      $(
        '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneMain_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
      ).hide(),
        alert(response);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      var errMessage =
        'An error occured serving your request. Please try again.';
      jqXHR && (errMessage = $.parseJSON(jqXHR.responseText).Message),
        $(
          '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneMain_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
        ).hide(),
        alert(errMessage);
    },
  });
}

function BindEvents(size, page) {
  $('#eventList').html(''),
    $('#divPagination').html(''),
    $(
      '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneRight2_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
    ).show();
  var Type = 0,
    Industry = 0,
    Business = 0,
    Month = 0;
  try {
    (Type = $('#ddlFilterType option:selected').val()),
      (Industry = $('#ddlFilterIndustry option:selected').val()),
      (Business = $('#ddlFilterBusiness option:selected').val()),
      (Month = $('#ddlFilterByMonth option:selected').val());
  } catch (err) {
    (Type = 0), (Industry = 0), (Business = 0), (Month = 0);
  }
  var EventFolderId = $('#hdnEventFolderId').val(),
    resultArray = EventFolderId.split(',').map(Number);
  try {
    void 0 === Type && (Type = 0),
      void 0 === Industry && (Industry = 0),
      void 0 === Business && (Business = 0),
      void 0 === Month && (Month = 0),
      void 0 === size && (size = 20);
  } catch (ex) {}
  $.ajax({
    type: 'POST',
    url: '/webmethods.aspx/eventsbind',
    data: JSON.stringify({
      lngFolderID: resultArray,
      lngType: Type,
      lngBusiness: Business,
      lngIndustry: Industry,
      strMonth: Month,
      intSize: size,
      intPage: page,
    }),
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (response) {
      $(
        '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneRight2_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
      ).hide();
      try {
        var text = response.d,
          splitText = text.split("<div id='divPagination'/>");
        if (-1 === splitText[0].indexOf("<main class='feed-container'></main>"))
          $('#eventList').html(splitText[0]),
            $('#divPagination').html(splitText[1]);
        else {
          $('#eventList .feed-container').css('display', 'none'),
            $('#eventList').html(splitText[0]);
          var message,
            month = $('#ddlFilterByMonth').find('option:selected'),
            type = $('#ddlFilterType').find('option:selected'),
            industry = $('#ddlFilterIndustry').find('option:selected');
          (message =
            '0' == month.val() && '0' == type.val() && '0' == industry.val()
              ? $("meta[name='No Results Message']").attr('content')
              : $("meta[name='No Results Message Filtered']").attr('content')),
            (message =
              '0' != month.val() && month.val()
                ? message.replace('[Month ]', month.text() + ' ')
                : message.replace('[Month ]', '')),
            (message =
              '0' != type.val() && type.val()
                ? message.replace('[Type ]', type.text() + ' ')
                : message.replace('[Type ]', '')),
            (message =
              '0' != industry.val() && industry.val()
                ? message.replace(
                    '[for Industry ]',
                    'for ' + industry.text() + ' ',
                  )
                : message.replace('[for Industry ]', '')),
            (message =
              '<main class="feed-container"><p>' + message + '</p></main>'),
            $('#eventList').html(message);
        }
        SetPushState({
          type: Type,
          business: Business,
          industry: Industry,
          month: Month,
          page: page,
        });
      } catch (ex) {}
    },
    failure: function (response) {
      $(
        '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneRight2_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
      ).hide(),
        alert(response);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      var errMessage =
        'An error occured serving your request. Please try again.';
      jqXHR && (errMessage = $.parseJSON(jqXHR.responseText).Message),
        $(
          '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneRight2_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
        ).hide(),
        alert(errMessage);
    },
  });
}

function BindBlogArchive(size, page) {
  $('#blogList').html(''),
    $('#divPagination').html(''),
    $(
      '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneMain_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
    ).show();
  var Topic = 0,
    Author = 0,
    Segment = 0,
    Month = 0,
    Taxonomy = 0;
  try {
    (Topic = $('#ddlFilterTopic option:selected').val()),
      (Author = $('#ddlFilterAuthor option:selected').val()),
      (Segment = $('#ddlFilterSegment option:selected').val()),
      (Month = $('#ddlFilterByMonth option:selected').val()),
      (Taxonomy = $('#ddlFilterTaxonomy option:selected').val());
  } catch (err) {
    (Topic = 0), (Author = 0), (Segment = 0), (Month = 0), (Taxonomy = 0);
  }
  var BlogFolderId = $('#hdnBlogFolderId').val(),
    resultArray = BlogFolderId.split(',').map(Number),
    PageID = $('#hdnPageID').val();
  try {
    void 0 === Topic && (Topic = 0),
      void 0 === Segment && (Segment = 0),
      void 0 === Month && (Month = 0),
      void 0 === Author && (Author = 0),
      void 0 === Taxonomy && (Taxonomy = 0),
      void 0 === BlogFolderId && (BlogFolderId = 0),
      void 0 === size && (size = 20);
  } catch (ex) {}
  $.ajax({
    type: 'POST',
    url: '/webmethods.aspx/blogarchivesbind',
    data: JSON.stringify({
      lngBlogFolderId: resultArray,
      lngTopic: Topic,
      lngAuthor: Author,
      lngSegment: Segment,
      lngTaxonomy: Taxonomy,
      strMonth: Month,
      intSize: size,
      intPage: page,
      lngPageId: PageID,
    }),
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (response) {
      $(
        '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneMain_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
      ).hide();
      try {
        var text = response.d,
          splitText = text.split("<div id='divPagination'/>");
        if ('' !== text)
          $('#blogList').html(splitText[0]),
            $('#divPagination').html(splitText[1]);
        else {
          $('#blogList').css('display', 'none'),
            $('#blogList').html(splitText[0]);
          var message,
            month = $('#ddlFilterByMonth').find('option:selected'),
            topic = $('#ddlFilterTopic').find('option:selected'),
            segment = $('#ddlFilterSegment').find('option:selected'),
            author = $('#ddlFilterAuthor').find('option:selected');
          (message =
            '0' == topic.val() && '0' == segment.val() && '0' == author.val()
              ? $("meta[name='No Results Message']").attr('content')
              : $("meta[name='No Results Message Filtered']").attr('content')),
            (message =
              '0' != month.val() && month.val()
                ? message.replace('[Month ]', month.text() + ' ')
                : message.replace('[Month ]', '')),
            (message =
              '0' != topic.val() && topic.val()
                ? message.replace('[Topic ]', topic.text() + ' ')
                : message.replace('[Topic ]', '')),
            (message =
              '0' != segment.val() && segment.val()
                ? message.replace(
                    '[about Segment ]',
                    'about ' + segment.text() + ' ',
                  )
                : message.replace('[about Segment ]', '')),
            (message =
              '0' != author.val() && author.val()
                ? message.replace('[by Author ]', 'by ' + author.text() + ' ')
                : message.replace('[by Author ]', '')),
            (message = '<p>' + message + '</p>'),
            $('#blogList').html(message),
            $('#blogList').removeAttr('style');
        }
        SetPushState({
          topic: Topic,
          author: Author,
          segment: Segment,
          month: Month,
          taxonomy: Taxonomy,
          page: page,
        }),
          $('html, body').animate(
            {
              scrollTop: 0,
            },
            0,
          );
      } catch (ex) {}
    },
    failure: function (response) {
      $(
        '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneMain_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
      ).hide(),
        alert(response);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      var errMessage =
        'An error occured serving your request. Please try again.';
      jqXHR && (errMessage = $.parseJSON(jqXHR.responseText).Message),
        $(
          '#ctl00_ctl00_ContentPlaceHolder1_ContentMain_DropZoneMain_uxColumnDisplay_ctl00_uxControlColumn_ctl00_uxWidgetHost_uxWidgetHost_widget_imgProgressBar',
        ).hide(),
        alert(errMessage);
    },
  });
}

function initializeAccesibleNavigation() {
  var triggers = $('.browse-tab:visible span.browse');
  triggers.attr('tabindex', 0),
    triggers
      .on('focus', function (ev) {
        $(this).on('keyup', function (e) {
          13 === (e.keyCode || e.which) &&
            (e.preventDefault(),
            $(ev.target).parents('.browse-tab').hasClass('browse-active')
              ? (hideBrowse(),
                $(ev.target)
                  .parents('.trigger')
                  .find('img')
                  .attr('src', '/McKesson/images/arrows/nav-right-arrow.png')
                  .css({
                    width: '8px',
                    height: '15px',
                  }))
              : (hideBrowse(),
                initBrowse($(ev.target).parents('.browse-tab').attr('id')),
                $('.trigger')
                  .find('img')
                  .attr('src', '/McKesson/images/arrows/nav-right-arrow.png'),
                $(ev.target)
                  .parents('.trigger')
                  .find('img')
                  .attr('src', '/McKesson/images/arrows/nav-right-arrow.png')
                  .css({
                    width: '15px',
                    height: '8px',
                  })));
        });
      })
      .on('blur', function () {
        $(this).unbind('keyup');
      });
}

function SetPushState(parameters) {
  var querystring = '';
  for (var key in parameters)
    parameters.hasOwnProperty(key) &&
      0 !== parameters[key] &&
      (querystring +=
        ('' === querystring ? '?' : '&') + key + '=' + parameters[key]);
  '' !== querystring && history.pushState('', '', querystring);
}

function medifacdSideRail() {
  if (-1 !== window.location.href.indexOf('medifacd')) {
    var siderail = $('.rightrailcontainer');
    0 === siderail.length && (siderail = $('.innerrightrailcontainer')),
      siderail.length > 0 &&
        ($('#skiptocontent').append(
          '<li><a href="#siderail">Skip to sidebar</a></li>',
        ),
        siderail.attr('id', 'siderail'),
        siderail.attr('role', 'region'),
        siderail.attr('aria-label', 'information'));
  }
}

function divideMenu() {
  function new_extra(parent) {
    var num_cols = 2,
      min_items = 5,
      max_items = 20,
      container = $(parent).find('.results-inner'),
      listClass = 'sub-list';
    container.each(function () {
      var items_per_col = [],
        items = $(this).find('ul:not(".list") li');
      items.length - 1 <= min_items && (num_cols = 1),
        items.length - 1 >= min_items &&
          items.length - 1 <= max_items &&
          (num_cols = 2),
        items.length - 1 > max_items && (num_cols = 3);
      var i,
        min_items_per_col = Math.floor(items.length / num_cols),
        difference = items.length - min_items_per_col * num_cols;
      for (i = 0; i < num_cols; i++)
        items_per_col[i] =
          i < difference ? min_items_per_col + 1 : min_items_per_col;
      var ia;
      for (ia = 0; ia < num_cols; ia++) {
        $(this)
          .parent()
          .find('.results-inner')
          .append(
            $(
              '<div class="extra new-extra"><div class="item"><span></span><ul class=' +
                listClass +
                '></ul></div></div>',
            ),
          );
        var j;
        for (j = 0; j < items_per_col[ia]; j++) {
          var k,
            pointer = 0;
          for (k = 0; k < ia; k++) pointer += items_per_col[k];
          $(this)
            .find('.' + listClass)
            .last()
            .append(items[j + pointer]);
        }
      }
      $(this)
        .find('.new-extra .item li')
        .each(function () {
          var title = $(this).attr('data-title'),
            next_title = $(this).next('li').attr('data-title');
          $(this).is(':first-child') &&
            $('<span>' + title + '</span>').insertBefore($(this)),
            title !== next_title &&
              'undefined' !== next_title &&
              $('<span>' + next_title + '</span>').insertBefore(
                $(this).next('li'),
              );
        }),
        $(this)
          .find('.new-extra .item ul li')
          .each(function () {
            if ($(this).is(':last-child')) {
              var title = $(this).attr('data-title'),
                next_col_title = $(this)
                  .parents('.new-extra')
                  .siblings()
                  .find('.item ul li')
                  .first()
                  .attr('data-title');
              if (title == next_col_title) {
                var elements_to_move = [];
                $(this)
                  .prevAll('li[data-title="' + title + '"]')
                  .each(function () {
                    elements_to_move.push($(this));
                  }),
                  elements_to_move.push($(this)),
                  (elements_to_move = elements_to_move.reverse()),
                  $(this)
                    .parents('.new-extra')
                    .find('ul span')
                    .each(function () {
                      $(this).text() == title && $(this).remove();
                    }),
                  $(elements_to_move).each(function () {
                    $(this).insertBefore(
                      $(this)
                        .parents('.new-extra')
                        .siblings()
                        .find('.item ul li')
                        .first(),
                    );
                  });
              }
            }
          }),
        $(this).find('.extra').not('.new-extra').remove();
    });
  }

  var main_mobile_link = $('.browse-tab.all').find('strong a').attr('id');
  void 0 !== main_mobile_link &&
    (main_mobile_link = main_mobile_link.split('-')[1]),
    $('.browse-tab.all').find('strong a').text(main_mobile_link),
    $('.browse-tab.single').each(function () {
      var parent = $(this),
        main_link = $(this).find('.sm-trigger strong a').attr('id');
      void 0 !== main_link && (main_link = main_link.split('-')[1]),
        $(this).find('.sm-trigger strong a').text(main_link);
      var taxonomy = $('meta[name=nav-tab]').attr('content');
      taxonomy && (taxonomy = taxonomy.toLowerCase());
      var menuTitle = parent.find('.trigger span').text();
      menuTitle && (menuTitle = menuTitle.toLowerCase()),
        taxonomy && taxonomy == menuTitle && parent.addClass('active-nav-item'),
        $(this)
          .find('.results-inner ul li')
          .each(function () {
            var this_title = $(this)
              .parents('.extra')
              .find('.item span')
              .text();
            $(this).parents('.extra').find('.item span').html();
            $(this).attr('data-title', this_title);
          }),
        $(this).find('.extra').length > 2 && new_extra(this);

      var $extra = $(this).find('.extra').first(),
        width = $extra.width(),
        next_width = $extra.next('.extra').width();

      Math.abs(width - next_width) > 90 &&
        (width >= next_width
          ? $extra.next('.extra').css('margin-right', '50px')
          : $extra.css('margin-right', '50px'));
    }),
    $('.browse-tab.single').click(function () {
      $(this).removeAttr('style'), $(this).siblings().removeAttr('style');
    });
}

function alignTabRight() {
  function right(element) {
    return $(document).width() - (element.offset().left + element.outerWidth());
  }

  if ($('.browse-tab.single').length > 0) {
    var last_right = right($('.browse-tab.single').last());
    $('.browse-tab.single')
      .not(':last')
      .each(function () {
        $(this).find('.results-wrapper').css('left', '0');
        var tab_right = right($(this).find('.results'));
        tab_right < last_right &&
          $(this)
            .find('.results-wrapper')
            .css('left', -1 * (last_right - tab_right));
      });
  }
}

function one_line(item) {
  if ($(item).hasClass('active')) {
    var line_height = parseFloat($(item).css('line-height'));
    $(item).outerHeight() < 2 * line_height &&
      $(item).find('a').addClass('one-line');
  }
}

function second_line() {
  if (!$('.page-tabs').hasClass('tall-menu')) {
    var first_item_left = $('.page-tab').first().offset().left + 5;
    $('.page-tab')
      .not(':first')
      .each(function () {
        if (
          ($('.second-line').remove(),
          $('.page-tab.active a').removeClass('hide-arrow'),
          $(this).offset().left == first_item_left)
        )
          return $('<div class="second-line"></div>').insertBefore($(this)), !1;
      });
  }
}

function checkTabs() {
  setTimeout(function () {
    $('.page-tab').each(function () {
      for (
        var line_height = parseFloat($(this).css('line-height')),
          tab_width = parseFloat($(this).css('max-width'));
        $(this).height() > 2 * line_height;

      )
        (tab_width += 5), $(this).css('max-width', tab_width);
    }),
      second_line();
  }, 1200);
}

function reduceTabs() {
  var last_tab_right,
    most_right = 0,
    tabs_width = parseFloat($('.page-tabs').outerWidth()),
    tabs_height = parseFloat($('.page-tabs').outerHeight());
  $('.page-tabs').hasClass('tall-menu') || $('.page-tabs').removeAttr('style'),
    $('.page-tab.active a').removeClass('one-line'),
    $window.width() < 546 &&
      ($('.page-tabs').css('background-image', 'url(' + icon + ')'),
      (bkg_size =
        $('.page-tabs').height() - $('.page-tab:eq(0)').position().top),
      $('.page-tabs').css('background-size', bkg_size),
      $('.page-tabs').css(
        'background-position',
        'right -' + bkg_size / 2.5 + 'px bottom -' + bkg_size / 10 + 'px',
      ),
      $('.page-tabs').css('background-repeat', 'no-repeat')),
    $('.page-tab').each(function () {
      var this_left = $(this).position().left;
      this_left > most_right &&
        ((most_right = this_left),
        (last_tab_right = parseFloat(most_right + $(this).width())));
    }),
    break_point > tabs_width + reduce_point
      ? setTimeout(function () {
          (two_lines_break = tabs_width),
            $('.page-tab')
              .each(function () {
                var line_height = parseFloat($(this).css('line-height')),
                  min_max_width = 40;
                for (
                  $(this).css('max-width', min_max_width);
                  $(this).height() > 2 * line_height;

                )
                  (min_max_width += 5), $(this).css('max-width', min_max_width);
              })
              .promise()
              .done(checkTabs()),
            $('.page-tab').each(function () {
              $(this).width() < $(this).find('a').outerWidth() &&
                $(this).css('max-width', $(this).find('a').outerWidth()),
                one_line(this);
            }),
            second_line();
        }, 50)
      : ($('.page-tab').removeAttr('style'),
        $('.page-tab.active a').removeClass('one-line')),
    tabs_width > two_lines_break &&
      two_lines_break > 0 &&
      $('.page-tab').removeAttr('style'),
    tabs_width - last_tab_right < reduce_point &&
      tabs_height > 60 &&
      ($('.page-tabs').addClass('reduced'), (reduce_margin = tabs_width)),
    $window.width() < 546 && $('.page-tabs').removeClass('reduced'),
    tabs_height > 200 &&
      0 === mobile_break &&
      ($('.page-tabs').removeClass('reduced'),
      $('.page-tabs').addClass('tall-menu'),
      $('.second-line').remove(),
      $('.page-tab').removeAttr('style'),
      (bkg_size =
        $('.page-tabs').height() - $('.page-tab:eq(0)').position().top),
      $('.page-tabs').css('background-image', 'url(' + icon + ')'),
      $('.page-tabs').css('background-size', bkg_size),
      $('.page-tabs').css(
        'background-position',
        'right -' + bkg_size / 2.5 + 'px bottom -' + bkg_size / 10 + 'px',
      ),
      (mobile_break = tabs_width)),
    mobile_break > 0 &&
      mobile_break < tabs_width &&
      ($('.page-tabs').removeClass('tall-menu'),
      $('.page-tabs').removeAttr('style'),
      $('.page-tab').removeAttr('style'),
      (mobile_break = 0),
      $('.page-tab.active a').removeClass('one-line'),
      reduceTabs());
}

function arrangeSearch() {
  $('#search-button').insertBefore('#sayt-view'),
    clearInterval(arrangeTimer),
    '' !== $searchField.val()
      ? $("label[for='search-field']").css('opacity', '0')
      : $("label[for='search-field']").css('opacity', '1');
}

function addURLtoQualtricsSurvey() {
  var listenerTimer = 0,
    iframeListener = setInterval(function () {
      (listenerTimer += 1),
        listenerTimer > 40 && clearInterval(iframeListener),
        $('iframe').length > 0 &&
          $('iframe').each(function () {
            if (
              $(this).attr('src') &&
              $(this).attr('src').indexOf('qualtrics.com') >= 0
            ) {
              var parentLocation = encodeURIComponent(window.location.href),
                iframeSrc =
                  $(this).attr('src') + '?parentLocation=' + parentLocation;
              $(this).attr('src', iframeSrc), clearInterval(iframeListener);
            }
          });
    }, 100);
}

function changeTab(tab) {
  'left' == tab
    ? (document.getElementById('left-tab').classList.toggle('active'),
      document.getElementById('left-tab-content').classList.toggle('active'),
      document.getElementById('right-tab').classList.toggle('active'),
      document.getElementById('right-tab-content').classList.toggle('active'))
    : (document.getElementById('right-tab').classList.toggle('active'),
      document.getElementById('right-tab-content').classList.toggle('active'),
      document.getElementById('left-tab').classList.toggle('active'),
      document.getElementById('left-tab-content').classList.toggle('active'));
}

$('#blogList').length > 0 &&
  $(document).ready(function () {
    var defualtTitle = $('#divTitleText').html();
    $('.filters select').unbind('change');
    try {
      var strMonth = getParameterByName('month');
      strMonth.length > 0 && $('#ddlFilterByMonth').val(strMonth);
    } catch (err) {}
    try {
      var strTopic = getParameterByName('topicValue');
      strTopic.length > 0 && $('#ddlFilterTopic').val(strTopic);
    } catch (err) {}
    try {
      var strAuthor = getParameterByName('author');
      strAuthor.length > 0 && $('#ddlFilterAuthor').val(strAuthor);
    } catch (err) {}
    try {
      var strSegment = getParameterByName('segment');
      strSegment.length > 0 && $('#ddlFilterSegment').val(strSegment);
    } catch (err) {}
    try {
      var strTaxonomy = getParameterByName('taxonomy');
      strTaxonomy.length > 0 && $('#ddlFilterTaxonomy').val(strTaxonomy);
    } catch (err) {}
    var page = 1;
    try {
      page = getParameterByName('page') || 1;
    } catch (err) {}
    try {
      $('#aspnetForm').attr('action');
      $('#ddlFilterByMonth').change(function () {
        BindBlogArchive($('#hdnPageSize').val(), 1);
      }),
        $('#ddlFilterTopic').change(function () {
          BindBlogArchive($('#hdnPageSize').val(), 1);
        }),
        $('#ddlFilterAuthor').change(function () {
          BindBlogArchive($('#hdnPageSize').val(), 1);
        }),
        $('#ddlFilterSegment').change(function () {
          BindBlogArchive($('#hdnPageSize').val(), 1);
        }),
        $('#ddlFilterTaxonomy').change(function () {
          BindBlogArchive($('#hdnPageSize').val(), 1);
        }),
        $('#subscribe').click(function (event) {
          var Topic = $('#ddlFilterTopic option:selected').val(),
            Author = $('#ddlFilterAuthor option:selected').val(),
            Segment = $('#ddlFilterSegment option:selected').val(),
            Taxonomy = $('#ddlFilterTaxonomy option:selected').val(),
            BlogFolderId =
              ($('#ddlFilterByMonth option:selected').val(),
              $('#hdnBlogFolderId').val());
          window.open(
            '/rss.aspx?blogs=yes&topic=' +
              Topic +
              '&author=' +
              Author +
              '&segment=' +
              Segment +
              '&blogid=' +
              BlogFolderId +
              '&taxonomy=' +
              Taxonomy,
          ),
            event.preventDefault();
        });
    } catch (err) {}
    BindBlogArchive($('#hdnPageSize').val(), page),
      $('.filter-set .reset').click(function () {
        $(this).hasClass('active') && $('#divTitleText').html(defualtTitle);
      });
  }),
  $('#eventList').length > 0 &&
    $(document).ready(function () {
      var filterbymonth = $('#ddlFilterByMonth'),
        filterbytype = $('#ddlFilterType'),
        filterbyindustry = $('#ddlFilterIndustry'),
        filterbybusiness = $('#ddlFilterBusiness');
      try {
        var strMonth = getParameterByName('month');
        strMonth.length > 0 && filterbymonth.val(strMonth);
      } catch (err) {}
      try {
        var strEventType = getParameterByName('eventtype');
        strEventType.length > 0 && filterbytype.val(strEventType);
      } catch (err) {}
      try {
        var strIndustry = getParameterByName('industry');
        strIndustry.length > 0 && filterbyindustry.val(strIndustry);
      } catch (err) {}
      try {
        var strBusiness = getParameterByName('business');
        strBusiness.length > 0 && filterbybusiness.val(strBusiness);
      } catch (err) {}
      var page = 1;
      try {
        page = getParameterByName('page') || 1;
      } catch (err) {}
      try {
        $('.filters select').change(function () {
          BindEvents($('#hdnPageSize').val(), 1);
        }),
          $('#subscribe').click(function (event) {
            var Type = $('#ddlFilterType option:selected').val(),
              Industry = $('#ddlFilterIndustry option:selected').val(),
              Business = $('#ddlFilterBusiness option:selected').val(),
              Month = $('#ddlFilterByMonth option:selected').val();
            window.open(
              '/rss.aspx?type=' +
                Type +
                '&industry=' +
                Industry +
                '&business=' +
                Business +
                '&month=' +
                Month,
              'McKesson_News',
            ),
              event.preventDefault();
          });
      } catch (ex) {}
      BindEvents($('#hdnPageSize').val(), page);
    }),
  $('#NewsList').length > 0 &&
    $(document).ready(function () {
      $('div').removeClass('PBViewing');
      var filterbymonth = $('#ddlFilterByMonth'),
        filterbytopic = $('#ddlFilterTopic'),
        filterbyindustry = $('#ddlFilterIndustry'),
        filterbybusiness = $('#ddlFilterBusiness');
      try {
        var strMonth = getParameterByName('month');
        strMonth.length > 0 && filterbymonth.val(strMonth);
      } catch (err) {}
      try {
        var strTopic = getParameterByName('topicValue');
        strTopic.length > 0 && filterbytopic.val(strTopic);
      } catch (err) {}
      try {
        var strIndustry = getParameterByName('industry');
        strIndustry.length > 0 && filterbyindustry.val(strIndustry);
      } catch (err) {}
      try {
        var strBusiness = getParameterByName('business');
        strBusiness.length > 0 && filterbybusiness.val(strBusiness);
      } catch (err) {}
      var page = 1;
      try {
        page = getParameterByName('page') || 1;
      } catch (err) {}
      $('.filters select').change(function () {
        BindPressRelease($('#hdnPageSize').val(), 1);
      });
      $('#subscribe').click(function (event) {
        var Topic = $('#ddlFilterTopic option:selected').val(),
          Industry = $('#ddlFilterIndustry option:selected').val(),
          Business = $('#ddlFilterBusiness option:selected').val(),
          Month = $('#ddlFilterByMonth option:selected').val();
        window.open(
          '/rss.aspx?topic=' +
            Topic +
            '&industry=' +
            Industry +
            '&business=' +
            Business +
            '&month=' +
            Month,
          'McKesson_News',
        );
        event.preventDefault();
      });
      BindPressRelease($('#hdnPageSize').val(), page);
    });
var $searchPlaceholderLong = 'Search',
  $searchPlaceholderShort = 'Search',
  $searchField = $('#search-field'),
  $window = $(window),
  navSet = !1;

var abTestExecuted = !1;
Date.now ||
  (Date.now = function () {
    return +new Date();
  }),
  $('body').hasClass('gateway') &&
    $('.hero-container .hero-header').children().length > 0 &&
    0 === $('.breadcrumb').height() &&
    $('.header').not('.hero').length > 0 &&
    $('.header').addClass('dark'),
  $('body').hasClass('gateway') &&
    0 === $('.hero-container .hero-header').children().length &&
    $('.section.backbox').length > 0 &&
    $('body.gateway .section>.section-intro:first-child').css(
      'padding-top',
      '50px',
    );

  (function ($, window, document) {
    'use strict';

    function renderContactEmbedded() {
      var aliId = ($(window).width(), window.location.href);
      (aliId = aliId.indexOf('aliId') >= 0 ? 'true' : 'false'),
        $(
          '.contact-embedded, .content-embedded, .promo-embedded, .embedded',
        ).each(function (index) {
          let contactEmbeddedID = $(this).data('embedded-id');
          let visibility = $(this).data('visibility');

          void 0 !== contactEmbeddedID &&
            null != contactEmbeddedID &&
            contactEmbeddedID.toString().length;
          visibility && $(this).addClass(visibility);

          let embedded_item = index + 1;
          $(
            '.contact-embedded-placeholder[data-embedded-item=' +
              embedded_item +
              ']',
          ).replaceWith($(this)),
            $(
              '.embedded-placeholder[data-embedded-item=' + embedded_item + ']',
            ).replaceWith($(this)),
            $(this).find('.video-overlay').length > 0 &&
              $($(this).find('.video-overlay')).insertAfter($('.st-container'));
        });
    }

    function mobilecheck() {
      var check = !1;
      return ((function(aa) {
          (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(aa) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(aa.substr(0, 4))) && (check = !0);
        }
      )(navigator.userAgent || navigator.vendor || window.opera),
        check);
    }

    function stickyNav() {
      ($scrollTop = $window.scrollTop()),
        $scrollTop
          ? ($header.addClass(stickyClass),
            $('.announcement-bar').length > 0 &&
              $header.css('top', $('.announcement-bar').height()))
          : ($header.removeClass(stickyClass),
            $('.announcement-bar').length > 0 &&
              $header.css('top', $('.announcement-bar').height()));
    }

    function stickyAlert() {
      ($scrollTop = $window.scrollTop()),
        $scrollTop
          ? $('.announcement-bar').addClass(stickyClass)
          : $('.announcement-bar').removeClass(stickyClass);
    }

    function initSubMenu(e) {
      e.stopPropagation(),
        ($this = $(e.currentTarget).parent()),
        $this.hasClass(activeClass)
          ? ($this.removeClass(activeClass).addClass(closingClass),
            window.setTimeout(function () {
              $('li.has-submenu.closing').removeClass(closingClass);
            }, 250))
          : ($('li.has-submenu.active').removeClass(activeClass),
            $this.addClass(activeClass));
    }

    function toTopScrolling(e) {
      return (
        e.preventDefault(),
        e.stopPropagation(),
        $('html, body').animate(
          {
            scrollTop: 0,
          },
          500,
        ),
        !1
      );
    }

    function backToTop() {
      ($scrollTop = $window.scrollTop()),
        $scrollTop
          ? $backToTop.addClass(activeClass)
          : $backToTop.removeClass(activeClass);
    }

    function pauseVideo(video) {
      VidyardV4.api.getPlayersByUUID(video)[0].pause();
    }

    function playVideo(video) {
      var players = VidyardV4.api.getPlayersByUUID(video);
      players[0]._ready && players[0].play();
    }

    function closeVideoOverlay() {
      pauseVideo($('.video-overlay.active').attr('id').split('-')[1]),
        $(videoOverlay).fadeOut(250).removeClass(activeClass),
        $('.close-video').off('click', closeVideoOverlay),
        $document.off('click', resetVideoOverlay);
    }

    function resetVideoOverlay(e) {
      $('.video-overlay').hasClass('active') && closeVideoOverlay();
    }

    function initVideoOverlay(e) {
      e.stopPropagation(),
        $(videoOverlay).removeClass('active'),
        $('#' + $(e.currentTarget).attr('data-video'))
          .fadeIn(250)
          .addClass(activeClass),
        $('.close-video').on('click', closeVideoOverlay),
        $document.on('click', resetVideoOverlay),
        playVideo($(e.currentTarget).attr('data-video').split('-')[1]);
    }

    function setHeight(e) {
      if (
        $('body.contact-us').length != 1 &&
        $('body.contact-us.sales-contacts').length != 1 &&
        $('body.contact-us.support-contacts').length != 1 &&
        window.location.pathname != '/'
      ) {
        var $el = $(e);
        $el.parent().height($el.outerHeight());
      }
    }

    function setRowHeight(e) {
      var currentDiv,
        currentTallest = 0,
        currentRowStart = 0,
        rowDivs = [],
        topPosition = 0,
        $el = $(e);
      $el.css('height', 'auto'),
        $el.each(function () {
          if (
            (($this = $(this)),
            (topPosition = $this.position().top),
            currentRowStart !== topPosition)
          ) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++)
              rowDivs[currentDiv].height(currentTallest);
            (rowDivs.length = 0),
              (currentRowStart = topPosition),
              (currentTallest = $this.height()),
              rowDivs.push($this);
          } else
            rowDivs.push($this),
              (currentTallest =
                currentTallest < $this.height()
                  ? $this.height()
                  : currentTallest);
          for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++)
            rowDivs[currentDiv].height(currentTallest);
        });
    }

    function setResourceHeight(e) {
      var currentTallest = 0,
        $el = $(e).find('.content');
      $el.css('height', 'auto'),
        $el.each(function () {
          $(this).height() > currentTallest &&
            (currentTallest = $(this).height());
        }),
        $el.each(function () {
          $(this).height(currentTallest);
        });
    }

    function setButtonHeight(e) {
      var currentTallest = 0,
        currentWidest = 0,
        $el = $(e).find('.button');

      $el.css('max-width', '92%'),
        $el.each(function () {
          $(this).height() > currentTallest &&
            (currentTallest = $(this).height()),
            $(this).width() > currentWidest &&
              (currentWidest = $(this).width());
        }),
        $el.each(function () {
          var span = $(this).children('span'),
            spanWidth = span.outerWidth() + 2;
          $(this).height(currentTallest),
            $(this).width(currentWidest),
            $(this).height() > 40 &&
              (span.css('display', 'inline'), (spanWidth = span.outerWidth()));

          //   document.documentMode || /Edge/.test(navigator.userAgent) ? span.css({
          //   display: "block",
          //   position: "relative",
          //   top: "50%",
          //   left: "50%",
          //   "-webkit-transform": "translate(-50%, -50%)",
          //   transform: "translate(-50%, -50%)",
          //   width: spanWidth,
          //   "max-width": "101%"
          // }) : span.css({
          //   display: "block",
          //   position: "relative",
          //   top: "50%",
          //   left: "50%",
          //   "-webkit-transform": "translate(calc(-50% + 0.5px),calc(-50% + 0.5px))",
          //   transform: "translate(calc(-50% + 0.5px),calc(-50% + 0.5px))",
          //   width: spanWidth,
          //   "max-width": "101%",
          // });
        }),
        $(e).parent('div').parents('div').find('.customer-login').length > 0 &&
          (($el = $(e).find('.button')),
          $el.css('height', 'auto'),
          $el.css('width', 'auto'),
          $el.find('span').removeAttr('style'));
    }

    function setImageHeight(e) {
      var currentTallest = 0,
        $el = $(e).children('figure');
      $el.css('height', 'auto'),
        $el.css('line-height', 'auto'),
        $el.each(function () {
          $(this).find('img').height() > currentTallest &&
            (currentTallest = $(this).find('img').height());
        }),
        $el.each(function () {
          $(this).height(currentTallest),
            $(this).css('line-height', currentTallest + 'px');
          var parent = $(this).parents('.contact-embedded');
          $window.width() >= 768 &&
            (parent.hasClass('right') || parent.hasClass('left')) &&
            $(this)
              .next('h4')
              .css('margin-top', currentTallest / 4);
        });
    }

    function setTitleHeight(e) {
      /*    var currentDiv, currentTallest = 0,
            currentRowStart = 0,
            rowDivs = [],
            topPosition = 0,
            $el = $(e);
        $el.css("height", "auto"), $el.each(function() {
            if ((($this = $(this)), (topPosition = $this.position().top), currentRowStart !== topPosition)) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) rowDivs[currentDiv].children(".title").height(currentTallest);
                (rowDivs.length = 0), (currentRowStart = topPosition), (currentTallest = $this.children(".title").height()), rowDivs.push($this);
            } else rowDivs.push($this), (currentTallest = currentTallest < $this.children(".title").height() ? $this.children(".title").height() : currentTallest);
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) rowDivs[currentDiv].children(".title").height(currentTallest);
        });
        */
    }

    function setParagraphHeight(e) {
      var currentTallest = 0,
        $el = $(e).children('p');
      /* $el.css("height", "auto"), $el.each(function() {
            $(this).height() > currentTallest && (currentTallest = $(this).height());
        }), $el.each(function() {
            $(this).height(currentTallest);
        });*/
    }

    function setSpanTitleHeight(e) {
      /*  var currentTallest = 0,
            $el = $(e).children("span.title, .component-h6");
        $el.css("height", "auto"), $el.each(function() {
            $(this).height() > currentTallest && (currentTallest = $(this).height());
        }), $el.each(function() {
            $(this).height(currentTallest);
        });
        */
    }

    function setSpanParagraphHeight(e) {
      /*  var currentTallest = 0,
            $el = $(e).children(".text, .component-text");
        $el.css("height", "auto"), $el.each(function() {
            $(this).height() > currentTallest && (currentTallest = $(this).height());
        }), $el.each(function() {
            $(this).height(currentTallest);
        });
        */
    }

    function productAnchors(e) {
      offset = 0;
      var data_group;
      return (
        $('.gn-menu-main').length > 0
          ? (offset = $('.gn-menu-main').height())
          : $('.sticky-nav').length > 0 && (offset = $('.header').height()),
        (data_group = $(
          '#' != $(e.currentTarget).attr('href')
            ? '[data-group="' +
                $(e.currentTarget).attr('href').substr(1).toLowerCase() +
                '"]'
            : '[data-group="' +
                $(e.currentTarget).attr('href').substr(0) +
                '"]',
        )),
        $('html, body').animate(
          {
            scrollTop: data_group.offset().top - offset - 20,
          },
          500,
        ),
        !1
      );
    }

    //$("[data-letter=" + $(e.currentTarget).parent().data("letter") + "]").addClass("active").siblings("[data-letter]").removeClass("active"),
    function scrollToAnchors(e) {
      $window.width() < 959 &&
        ($(e.currentTarget)
          .parent()
          .toggleClass('active')
          .siblings()
          .removeClass('active'),
        $window.scrollTop() > $(e.currentTarget).parent().offset().top &&
          $('html, body').animate(
            {
              scrollTop: $(e.currentTarget).parent().offset().top,
            },
            250,
          ));
    }

    function moveCheckedFilters() {
      $window.width() < 1025
        ? $('.checked-filters').hasClass('moved') ||
          ((filters = $('.checked-filters').detach()),
          filters.appendTo('.filter-container').addClass('moved'))
        : $('.checked-filters').hasClass('moved') &&
          ((filters = $('.checked-filters').detach()),
          filters.prependTo('.filter-container').removeClass('moved'));
    }

    function moveSelectedFilters() {
      var selected = $('.filter-trigger.active').children().data('filter');
      $('[data-filter="' + selected + '"]')
        .parent()
        .addClass('active');
    }

    function closeAnnouncement() {
      $body.removeClass('has-announcement'),
        $('.announcement-bar').remove(),
        $header.css('top', '0');
    }

    function showLocations(e) {
      $(e.currentTarget).parent().toggleClass('active');
    }

    function closeRegionSwitcher(e) {
      // "region-switcher" === e.target.id || "region-switcher-selector" === e.target.id || "region-switcher-selector-text" === e.target.id ? $("#region-switcher").hasClass("active") || $("#region-switcher").addClass("active") : $("#region-switcher").hasClass("active") && $("#region-switcher").removeClass("active");
    }

    function switchRegions(e) {
      $('.region-switcher .current-region')
        .attr('class', '')
        .addClass(
          $(e.currentTarget).data('region') + ' current-region sm-trigger',
        ),
        $('.region-switcher .current-region span').text(
          $(e.currentTarget).find('span').text(),
        );
    }

    function regionSwitcher(e) {
      $(e.currentTarget).toggleClass(activeClass);
    }

    function filterCheck(e) {
      e.preventDefault(),
        $('input#' + $(e.currentTarget).attr('class')).prop('checked', !1),
        $(e.currentTarget).remove(),
        $('.checked-filters ul').children().length < 1 &&
          $('.checked-filters').removeClass('active');
    }

    function signUpSubmit(e) {
      13 === (code = e.keyCode || e.which) && e.preventDefault();
    }

    function validateName(input) {
      var re;
      '' !== input.value &&
      'Enter your real name or a username' !== input.value &&
      'Enter your first name' !== input.value &&
      'Enter your last name' !== input.value
        ? ((re = /^\s+$/i),
          re.test(input.value)
            ? $(input).parent().addClass('has-error')
            : $(input).parent().removeClass('has-error'))
        : $(input).parent().addClass('has-error');
    }

    function validateEmail(input) {
      var re;
      '' !== input.value &&
      'Enter your real name or a username' !== input.value &&
      'Enter Email Address' !== input.value &&
      'Email Address' !== input.value &&
      'Email' !== input.value
        ? ((re = /^[A-Z0-9._%+\-]+@([A-Z0-9\-]+\.)+[A-Z]{2,4}$/i),
          re.test(input.value)
            ? $(input).parent().removeClass('has-error')
            : $(input).parent().addClass('has-error'))
        : $(input).parent().addClass('has-error');
    }

    function validateComment(input) {
      var re;
      '' !== input.value && 'Enter your comment' !== input.value
        ? ((re = /^\s+$/i),
          re.test(input.value)
            ? $(input).parent().addClass('has-error')
            : $(input).parent().removeClass('has-error'))
        : $(input).parent().addClass('has-error');
    }

    function closeError(e) {
      $(e.currentTarget).parent().parent().removeClass('has-error');
    }

    function resetForm() {
      $('.active').removeClass('active'),
        $('.form').show(),
        $('input').each(function () {
          $(this).val('');
        });
    }

    function showPatternGroup(e) {
      $('.main').hide(),
        $('#pattern-library').show(),
        $('.pattern').hide(),
        $('.directory').hide(),
        $('.patterns').show(),
        $('#' + $(e.currentTarget).data('content')).show(),
        'heros' === $(e.currentTarget).data('content') && setProportion(),
        ('executive-officers' !== $(e.currentTarget).data('content') &&
          'contact-blocks' !== $(e.currentTarget).data('content') &&
          'featured-segments' !== $(e.currentTarget).data('content')) ||
          $('.segment-list').each(function () {
            $(this)
              .children('.segment')
              .each(function () {
                $(this).children('figure').length > 0 &&
                  ($(this).addClass('has-image'), (hasImage = !0));
              }),
              !0 === hasImage && setImageHeight($(this).children('.segment')),
              setTitleHeight($(this).children('.segment')),
              setParagraphHeight($(this).children('.segment'));
          }),
        'latest-news' === $(e.currentTarget).data('content') &&
          ($('.section.latest-articles').each(function () {
            $window.width() > 536
              ? setRowHeight($(this).find(article))
              : $(this).find(article).css('height', 'auto');
          }),
          $('.section.related-and-popular').each(function () {
            $window.width() > 536
              ? setRowHeight($(this).find(article))
              : $(this).find(article).css('height', 'auto');
          })),
        'related-content' === $(e.currentTarget).data('content') &&
          $('.related-products').each(function () {
            setSpanTitleHeight($(this).find(product)),
              setSpanParagraphHeight($(this).find(product));
          }),
        'carousel' === $(e.currentTarget).data('content') &&
          $('.carousel .rotator').resize(),
        'office-locations' === $(e.currentTarget).data('content') &&
          $('.locations').masonry({
            itemSelector: '.location',
            columnWidth: function (containerWidth) {
              return containerWidth / 2;
            },
            isAnimated: !0,
            layoutPriorities: {
              shelfOrder: 4,
            },
          }),
        'product-resources' === $(e.currentTarget).data('content') &&
          $('.page-resources').each(function () {
            setResourceHeight($(this).find('.resource'));
          }),
        'featured-content' === $(e.currentTarget).data('content') &&
          ($window.width() > 618
            ? $('.visual-split.has-image').each(function () {
                setHeight($(this).find('.visual-copy'));
              })
            : $('.visual-split.has-image').each(function () {
                $(this).children('.wrapper').css('height', 'auto');
              })),
        $('.patterns > header h6, .component-h6')
          .empty()
          .text($(e.currentTarget).text()),
        $('html, body').animate(
          {
            scrollTop: 0,
          },
          500,
        );
    }

    function switchPage(e) {
      $('.main').hide(), $('#' + $(e.currentTarget).data('page')).show();
    }

    function centerVideo() {
      var centerX =
          (($('#video-holder').width() >> 1) - ($('#BCPlayer').width() >> 1)) |
          0,
        centerY =
          (($('#video-holder').height() >> 1) -
            ($('#BCPlayer').height() >> 1)) |
          0;
      $('#BCPlayer').css({
        left: centerX,
        top: centerY,
      });
    }

    function getProportion() {
      var windowWidth = $('#video-holder').width(),
        windowHeight = $('#video-holder').height(),
        windowProportion = windowWidth / windowHeight,
        proportion = windowHeight / 550;
      return (
        windowProportion >= 1.78 && (proportion = windowWidth / 979), proportion
      );
    }

    function setProportion() {
      var proportion = getProportion();
      $('#BCPlayer video').width(979 * proportion),
        $('#BCPlayer video').height(550 * proportion),
        $('#BCPlayer video')
          .parent()
          .height(550 * proportion),
        centerVideo();
    }

    function resizeFunctions() {
      $('.modal-filter').length > 0 &&
        $window.width() > 1024 &&
        (hideFilterModal(),
        moveSelectedFilters(),
        $('.filter-tag').css('display', 'none')),
        $('.search-filters').find('.active').length > 0 &&
          $window.width() < 1024 &&
          (moveSelectedFilters(),
          $('.filter-tag').css('display', 'inline-block')),
        $('.select2-container--open').length > 0 &&
          $window.width() < 1024 &&
          $('.pretty-select').select2('close'),
        $('#BCPlayer').length > 0 &&
          (setProportion(),
          $window.width() > 1024
            ? $('#BCPlayer').hasClass('video-disabled') &&
              (videojs('BCPlayer').play(),
              $('#BCPlayer').removeClass('video-disabled'))
            : $('#BCPlayer').hasClass('video-disabled') ||
              (videojs('BCPlayer').pause(),
              $('#BCPlayer').addClass('video-disabled'))),
        $('.section.latest-articles').length > 0 &&
          ($window.width() > 666
            ? $('.section.latest-articles').each(function () {
                setRowHeight($(this).find(article));
              })
            : $('.section.latest-articles').each(function () {
                $(this).find(article).css('height', 'auto');
              })),
        $('.section.related-and-popular').length > 0 &&
          ($window.width() > 536
            ? $('.section.related-and-popular').each(function () {
                setRowHeight($(this).find(article));
              })
            : $('.section.related-and-popular').each(function () {
                $(this).find(article).css('height', 'auto');
              })),
        $('.related-products').length > 0 &&
          ($window.width() > 666
            ? $('.related-products').each(function () {
                setSpanTitleHeight($(this).find(product)),
                  setSpanParagraphHeight($(this).find(product));
              })
            : $('.related-products').each(function () {
                $(this).find('.title').css('height', 'auto'),
                  $(this).find('.text').css('height', 'auto');
              })),
        $('.segment-list').length > 0 &&
          ($window.width() > 536
            ? $('.segment-list').each(function () {
                $(this).find('.segment .button').length > 1 &&
                  setButtonHeight($(this).find('.segment'));
              })
            : $('.segment-list').each(function () {
                $(this).find('.segment .button').removeAttr('style'),
                  $(this).find('.segment .button span').removeAttr('style');
              })),
        $('.products').length > 0 &&
          ($window.width() > 536
            ? $('.products').each(function () {
                setButtonHeight($(this).find('.product'));
              })
            : $('.products').each(function () {
                $(this).find('.segment .button').removeAttr('style'),
                  $(this).find('.product .button span').removeAttr('style');
              })),
        $('.page-tabs').not('.contact-page').length > 0 && reduceTabs(),
        $('.search-results').length > 0 &&
          ($window.width() < 1025
            ? $('.filter-set').each(function () {
                $(this).children('h5').hasClass('active') &&
                  ($(this).children('h5').removeClass('active'),
                  $(this).children('.filters').removeClass('active'));
              })
            : $('.filter-set').each(function () {
                $(this).children('h5').hasClass('active') ||
                  ($(this).children('h5').addClass('active'),
                  $(this).children('.filters').addClass('active'));
              })),
        $('.checked-filters').length > 0 && moveCheckedFilters(),
        $('.reset').length > 0 &&
          $window.width() < 1025 &&
          ($('.search-filters-container').hasClass('collapsed') ||
            $('.search-filters-container').addClass('collapsed')),
        $('.announcement-bar').length > 0 &&
          $header.css('top', $('.announcement-bar').height()),
        $window.width() > 1e3
          ? 'Browse by category' !== $showBrowseTriggerText.html() &&
            ($showBrowseTriggerText.html('Browse by category'),
            $hideBrowseTriggerText.html('Hide categories'))
          : 'Browse' !== $showBrowseTriggerText.html() &&
            ($showBrowseTriggerText.html('Browse'),
            $hideBrowseTriggerText.html('Hide')),
        $window.width() > 667
          ? 'Enter Email Address' !== $emailField.attr('placeholder') &&
            $emailField.attr('placeholder', 'Enter Email Address')
          : 'Email' !== $emailField.attr('placeholder') &&
              $emailField.attr('placeholder', 'Email'),
          GatewayHeroContent(),
        centerHeroContent(),
        adjustPersonalizedHeroHeight(),
        reloadFeedbackIframe(),
        $('body.our-stories').length > 0 && resizeEllipsis();
    }

    function windowResize() {
      $window.width() !== $lastWidth &&
        (clearTimeout(resizeTimer),
        (resizeTimer = window.setTimeout(resizeFunctions, 200)),
        ($lastWidth = $window.width()));
    }

    function windowLoadResize() {
      var windowWidth = $(window).width();
      if (
        (fixDropdownsPosition(),
        initializeAccesibleNavigation(),
        $('.login-featured').length > 0 &&
          $window.width() > 1024 &&
          setRowHeight($('.segment')),
        windowWidth >= 667)
      ) {
        var htZone2 = $('#homezone2').height(),
          htZone3 = $('#homezone3').height();
        htZone2 > htZone3
          ? $('#homezone3').height(htZone2)
          : $('#homezone2').height(htZone3);
      }

      $('body').hasClass('gateway') &&
        $('.section.hero').length > 0 &&
        (windowWidth < 619 && 0 === $('.breadcrumb').height()
          ? ($('.section.hero .section-intro').css('top', '140px'),
            $('.section.hero .hero-container').css('padding-top', '120px'))
          : ($('.section.hero .section-intro').css('top', ''),
            $('.section.hero .hero-container').css('padding-top', ''))),
        (window.getSessionData = function (index) {
          var sessionData = window.sessionCamRecorder.sessionId(),
            sessionArray = [];
          if (
            sessionData.length > 0 &&
            ((sessionArray = sessionData.split(',')), sessionArray.length > 1)
          )
            return sessionArray[index];
        });

      var sessionCamTimer = setInterval(function () {
        if (void 0 !== window.sessionCamRecorder) {
          var sessionId = window.getSessionData(0),
            startTime = window.getSessionData(1),
            sessionURL =
              'https://console.sessioncam.com/Console/Recordings/PlaybackSession?';
          if (
            (clearInterval(sessionCamTimer),
            void 0 !== sessionId && void 0 !== startTime)
          ) {
            sessionURL =
              sessionURL + 'sessionId=' + sessionId + '&starttime=' + startTime;
            for (var frames = window.frames, i = 0; i < frames.length; i++)
              frames[i].postMessage(['sessionCamId', sessionURL], '*');
          }
        }
      }, 1e3);

      $('.visual-split.has-image').length > 0 &&
        (windowWidth > 618
          ? $('.visual-split.has-image').each(function () {
               if ($(this).find('.video-overlay').length > 0) {
                $($(this).find('.video-overlay')).insertAfter(
                  $('.st-container'),
                )
               }
                $(this).find('.promo-wrapper').removeAttr('style');
                $(this)
                  .parents('.tab-container')
                  .find('.PBViewing .PBItem .widget .content').length > 0 &&
                  $(this).parent().removeClass('content');
              $(this).find(".secondary-items").length <= 0 ?
                  setHeight($(this).find(".visual-copy")) :
                  $(this).find(".secondary-items").height() < $(this).find(".visual-image").height() &&
                  windowWidth > 768 && ($(this).hasClass("transparentBG") ?
                      $(this).find(".promo-wrapper").height($(this).find(".visual-image").height()) :
                      $(this).find(".promo-wrapper").height($(this).find(".visual-image").height() + 160)
                  );                          
            })
          : $('.visual-split.has-image').each(function () {
              $(this).find('.video-overlay').length > 0 &&
                $($(this).find('.video-overlay')).insertAfter(
                  $('.st-container'),
                );
              $(this).find('.promo-wrapper').removeAttr('style');
              $(this).children('.wrapper').css('height', 'auto');
            })
        );



        $('.visual-split').length > 0 &&
            ($('body').hasClass('gateway') || $('body').hasClass('content-hub')) &&
          $('.visual-split').each(function () {
            if ($(this).find('.promo-wrapper').length > 0) {
              var original_style = $(this).attr('style'),
                data_original_style = $(this).data('original-style');
              if (
                (original_style && $(this).addClass('inline-style'),
                data_original_style
                  ? ($(this).removeAttr('style'),
                    $(this).hasClass('inline-style') &&
                      $(this).attr('style', data_original_style))
                  : $(this).attr('data-original-style', original_style),
                $(this).find('.visual-image').length > 0)
              ) {
                var original_visual_image_style = $(this)
                  .find('.visual-image')
                  .data('original-style');
                if (
                  (original_visual_image_style
                    ? ($(this).find('.visual-image').removeAttr('style'),
                      $(this)
                        .find('.visual-image')
                        .attr('style', original_visual_image_style))
                    : $(this)
                        .find('.visual-image')
                        .attr(
                          'data-original-style',
                          $(this).find('.visual-image').attr('style'),
                        ),
                  $(this).find('.image-link').length > 0 && windowWidth > 618)
                )
                  if (
                    ($(this).find('.image-link').removeAttr('style'),
                    $(this).hasClass('PromoPrimary'))
                  ) {
                    var text_width =
                      $(this).find('.visual-copy.copy')[0].style.width;
                    text_width = parseInt(text_width.split('%')[0]);
                    var image_width = 100 - text_width;
                    $(this)
                      .find('.image-link')
                      .attr('style', 'width: ' + image_width + '%; z-index: 2');
                  } else
                    $(this)
                      .find('.image-link')
                      .attr(
                        'style',
                        'width: ' +
                          $(this).find('.visual-image')[0].style.width,
                      ),
                      $(this)
                        .find('.visual-image')
                        .attr('style', 'width: 100%');
              }
              var original_visual_copy_style = $(this)
                .find('.visual-copy')
                .data('original-style');
              if (
                (original_visual_copy_style
                  ? ($(this).find('.visual-copy').removeAttr('style'),
                    $(this).find('.visual-copy > *').removeAttr('style'),
                    $(this)
                      .find('.visual-copy')
                      .attr('style', original_visual_copy_style))
                  : $(this)
                      .find('.visual-copy')
                      .attr(
                        'data-original-style',
                        $(this).find('.visual-copy').attr('style'),
                      ),
                $(this).find('.secondary-items').length > 0)
              ) {
                var original_secondary_items_style = $(this)
                  .find('.secondary-items')
                  .data('original-style');
                original_secondary_items_style
                  ? ($(this).find('.secondary-items').removeAttr('style'),
                    $(this)
                      .find('.secondary-items')
                      .attr('style', original_secondary_items_style))
                  : $(this)
                      .find('.secondary-items')
                      .attr(
                        'data-original-style',
                        $(this).find('.secondary-items').attr('style'),
                      );
              }
              if (windowWidth > 768) {
                if (
                  !$(this).hasClass('transparent') &&
                  $(this).find('.secondary-items').length > 0
                ) {
                  $(this).removeAttr('style');
                  var back_color = $(this).css('background-color'),
                    back_height = 0;
                  'none' !== $(this).find('.visual-copy').css('display')
                    ? (back_height =
                        $(this).find('.visual-copy').outerHeight() + 160)
                    : $(this).hasClass('has-image') &&
                      (back_height =
                        $(this).find('.visual-image').height() + 160),
                    $(this).hasClass('transparent, transparentBG') ||
                      $(this).removeClass('skyblueBG'),
                    $(this).find('.gateway-section-back').remove(),
                    $(this).prepend(
                      '<div class="gateway-section-back" style="width:100%;height;z-index:1;position:absolute;top:50%;transform: translate(0,-50%);left:0;background-color:"' +
                        back_color +
                        '"></div>',
                    ),
                    $(this).css('background-color', 'transparentBG');
                }
                if ($(this).find('.secondary-items.horizontal').length > 0) {
                  var visual_copy_width =
                      $(this).find('.visual-copy')[0].style.width,
                    visual_copy_padding_right = parseInt(
                      $(this).find('.visual-copy').css('padding-right'),
                    );
                  if ('0%' != visual_copy_width) {
                    $(this).find('.visual-copy').css('width', '100%'),
                      $(this).hasClass('rtl') &&
                        $(this)
                          .find('.visual-copy > *')
                          .css({
                            width: visual_copy_width,
                            'margin-left': 0,
                            'padding-right':
                              2 * visual_copy_padding_right + 'px',
                          }),
                      $(this).hasClass('ltr') &&
                        $(this)
                          .find('.visual-copy > *')
                          .css({
                            width: visual_copy_width,
                            'margin-right': 0,
                            'padding-left':
                              2 * visual_copy_padding_right + 'px',
                            'margin-left': 'auto',
                          }),
                      $(this).height(
                        $(this)
                          .find('.secondary-items.horizontal')
                          .outerHeight(),
                      );
                    var visual_copy_top =
                      ($(this).height() -
                        $(this).find('.visual-copy').outerHeight()) /
                      2;
                    $(this)
                      .find('.visual-copy')
                      .css({
                        position: 'absolute',
                        top: visual_copy_top + 'px',
                      });
                  } else
                    $(this).height(
                      $(this).find('.secondary-items.horizontal').outerHeight(),
                    ),
                      $(this).find('.secondary-items.horizontal').css({
                        left: 0,
                        right: 0,
                      });
                }
              } else {
                if ($(this).find('.secondary-items.horizontal').length > 0) {
                  $(this).find('.gateway-section-back').remove(),
                    $(this).removeAttr('style');
                  var mobile_visual_copy_width =
                      $(this).find('.visual-copy')[0].style.width,
                    mobile_visual_copy_height = $(this)
                      .find('.visual-copy')
                      .outerHeight(),
                    mobile_secondary_height = $(this)
                      .find('.secondary-items.horizontal')
                      .outerHeight();
                  '0%' != mobile_visual_copy_width
                    ? ($(this)
                        .find('.visual-copy')
                        .attr(
                          'style',
                          'height:' +
                            parseInt(
                              mobile_visual_copy_height +
                                mobile_secondary_height +
                                40,
                            ) +
                            'px;width:90% !important; margin: auto;',
                        ),
                      $(this)
                        .find('.secondary-items.horizontal')
                        .css({
                          top: 1 * mobile_visual_copy_height,
                          position: 'absolute',
                        }))
                    : ($(this)
                        .find('.secondary-items.horizontal')
                        .addClass('secondary-only'),
                      $(this).find('.visual-copy').css({
                        height: 0,
                        margin: 0,
                        padding: 0,
                      }));
                }
                if ($(this).find('.secondary-items').length > 0) {
                  '0%' == $(this).find('.visual-copy')[0].style.width &&
                    $(this).find('.visual-copy').css('display', 'none');
                }
              }
            }
          });

        $('.segments').length > 0 &&
          $('.segments:not(.home-employee)').each(function () {
            $(this).find('.section-intro').length < 1 &&
              $(this).find('.segment').length <= 3 &&
              $(this).addClass('no-header'),
              $(this)
                .find('.segment')
                .each(function () {
                  $(this).children('figure').length > 0 &&
                    ($(this).addClass('has-image'), (hasImage = !0));
                }),
              !0 === hasImage && setImageHeight($(this).find('.segment')),
              windowWidth > 666
                ? (setTitleHeight($(this).find('.segment')),
                  setParagraphHeight($(this).find('.segment')))
                : ($(this)
                    .find('.segment')
                    .children('.title')
                    .css('height', 'auto'),
                  $(this).find('.segment').children('p').css('height', 'auto'));
          });

        $('.segments.home-employee').length > 0 &&
          setRowHeight($('.segments.home-employee .segment-list .segment'));

        $('#st-trigger-effects').is(':visible')
          ? backToTop()
          : $backToTop.removeClass(activeClass);

        $('.login-featured').length > 0 &&
          $window.width() > 1024 &&
          setRowHeight($('.segment'));

        $('.categories').length > 0 && $('.categories').masonry();
        cleanFooterLinks(eventtype);
        medifacdSideRail();
        alignTabRight();

      if (window.location.hash) {
        const anchorTarget = window.location.hash;
        const $anchorTarget = $(anchorTarget);
        if ($anchorTarget.length === 0) return;
        $('html, body').animate(
          {
            scrollTop: $anchorTarget.offset().top - 20,
          },
          200,
        );
      }
    }

    function windowScroll() {
      $('#st-trigger-effects').is(':visible')
        ? backToTop()
        : ($body.hasClass('sticky-nav') && stickyNav(),
          $('.announcement-bar').length > 0 && stickyAlert());
    }

    function hideFilterPopupWhenClickOutside(e) {
      $(document).on('click', function (e) {
        if (
          'label' !== e.target.className &&
          'search-filter-sets' !== e.target.className &&
          !$(e.target).parents('.search-filter-sets').length
        ) {
          var filterSets = $('.search-filters-container > .search-filter-sets');
          filterSets.hasClass('active') && filterSets.removeClass('active');
        }
        var modalFilter = $('.modal-filter');
        0 === modalFilter.has(e.target).length &&
          modalFilter.hasClass('active') &&
          hideFilterModal();
      });
    }

    function showFilterModal(e) {
      e.stopPropagation(),
        $('.modal-filter').fadeIn(),
        $('.modal-filter').addClass('active'),
        $('.floating-filter').addClass('active');
    }

    function hideFilterModal() {
      $('.modal-filter').fadeOut(),
        $('.modal-filter').removeClass('active'),
        $('.floating-filter').removeClass('active');
    }

    function clearFilterOfModalFilter() {
      $('.filter-trigger.active').length > 0 &&
        $('.filter-trigger.active').removeClass('active'),
        $('.filter-tag').css('display', 'none'),
        $('.reset').removeClass('active'),
        $('.apply, .cancel').removeClass('active'),
        $('.apply, .cancel').prop('disabled', !0);
    }

    function selectFilterOfModalFilter(e) {
      clearFilterOfModalFilter(),
        $(e.target).parent().addClass('active'),
        $('.apply, .cancel').addClass('active'),
        $('.apply, .cancel').prop('disabled', !1),
        $('.reset').addClass('active');
    }

    function doneFilterOfModalFilter() {
      hideFilterModal(), $('.apply, .cancel').prop('disabled', !1);
    }

    function moveModalFilterToMainContainer() {
      $('body').prepend($('.modal-filter'));
    }

    function fixDropdownsPosition() {
      // $("#functions").height() > 50 ? $(".results-wrapper").css("top", "80px") : $(".results-wrapper").css("top", "60px");
      }

      $(document).on('click', 'a[href^="#"]', function (event) {
          event.preventDefault();

          var targetOffset = $($.attr(this, 'href')).offset().top - 20;
          $('html, body').animate({
              scrollTop: targetOffset
          }, 200);

          var targetID = $.attr(this, 'href').substring(1);
          if (targetID) {
              history.pushState(null, null, '#' + targetID);
          }
      });

      function documentReady() {

          $("#bgImage").each(function () {
              if ($(this).find('.title').hasClass('invisible')) {
                  $(this).find(".description").addClass('notitle');
              }
          });
          $(window).resize(function () {
              $("#bgImage").each(function () {
                  if ($(this).find('.title').hasClass('invisible')) {
                      $(this).find(".description").addClass('notitle');
                  }
              });
          });
      (navSet = !0),
        fixDropdownsPosition(),
        divideMenu(),
        0 !== $('.sitemapul').length &&
          $('.sitemapul').each(function () {
            0 === $(this).children('li').length &&
              $(this).prev('h6, .component-h6').addClass('sitemap-title-link');
          }),
        $('#BCPlayer').length > 0 &&
          ($('#BCPlayer').fadeIn(100),
          window.setTimeout(function () {
            $('#BCPlayer video').removeAttr('controls'),
              $('#BCPlayer video').prop('muted', !0),
              videojs('BCPlayer').volume(0);
          }, 150),
          setProportion(),
          $window.width() < 1025 &&
            isMobile &&
            (videojs('BCPlayer').pause(),
            $('#BCPlayer').addClass('video-disabled'))),
        $('#gn-menu').length > 0 &&
          ((patternMenu = new GnMenu(document.getElementById('gn-menu'))),
          $('.gn-submenu .sub-item').on('click', showPatternGroup),
          $('.gn-menu-main .page-trigger').on('click', switchPage),
          $('.gn-menu .parent-item').on('click', function (e) {
            return (
              e.preventDefault(),
              e.stopPropagation(),
              $(this).next('.gn-submenu').toggle(),
              !1
            );
          })),
        $('.region-switcher').length > 0 &&
          $('.navbar-collapse').addClass('has-region-switcher'),
        $searchField.on('focusout', function () {});
      var triggers = $('.accordion .toggle');
      if (
        ($('.accordion .toggle').attr('tabindex', 0),
        triggers
          .on('focus', function (ev) {
            $(this).on('keyup', function (e) {
              13 === (e.keyCode || e.which) &&
                (e.preventDefault(), $(this).click());
            });
          })
          .on('blur', function () {
            $(this).unbind('keyup');
          }),
        $window.width() > 1e3
          ? ($showBrowseTriggerText.html('Browse by category'),
            $hideBrowseTriggerText.html('Hide categories'))
          : ($showBrowseTriggerText.html('Browse'),
            $hideBrowseTriggerText.html('Hide')),
        $window.width() > 667
          ? $emailField.attr('placeholder', 'Enter Email Address')
          : $emailField.attr('placeholder', 'Email'),
        $('.main-content').length > 0 &&
          $('.main-content').each(function () {
            $(this).find('.featured-media').length > 0 &&
              ($(this).find('.featured-media').hasClass('no-media') ||
                $(this).addClass('has-media'));
          }),
        $('.tweet-quote').length > 0 &&
          ((str = document.getElementById('tweet-text').innerHTML),
          (tweetTxt = encodeURIComponent(str)),
          (document.getElementById('tweet-link').href =
            'https://twitter.com/intent/tweet?text=' + tweetTxt)),
        $('.section.latest-articles').length > 0 &&
          $('.section.latest-articles').each(function () {
            $window.width() > 666
              ? setRowHeight($(this).find(article))
              : $(this).find(article).css('height', 'auto');
          }),
        $('.section.main-content').length > 0 &&
          $('.section.main-content').each(function () {
            $(this).find('aside').length > 0 && $(this).addClass('has-sidebar');
          }),
        $('.section.listing').length > 0 &&
          $('.section.listing').each(function () {
            $(this).find('.filter-container').length > 0 &&
              $(this).find('.listing-wrapper').addClass('has-filters');
          }),
        $('.section.related-and-popular').length > 0 &&
          $('.section.related-and-popular').each(function () {
            $window.width() > 536
              ? setRowHeight($(this).find(article))
              : $(this).find(article).css('height', 'auto');
          }),
        $('.related-products').length > 0 &&
          $window.width() > 666 &&
          $('.related-products').each(function () {
            setSpanTitleHeight($(this).find(product)),
              setSpanParagraphHeight($(this).find(product));
          }),
        $('.segment-list').length > 0 &&
          ($window.width() > 536
            ? $('.segment-list').each(function () {
                $(this).find('.segment .button').length > 1 &&
                  setButtonHeight($(this).find('.segment'));
              })
            : $('.segment-list').each(function () {
                $(this).find('.segment .button').removeAttr('style'),
                  $(this).find('.segment .button span').removeAttr('style');
              })),
        $('.products').length > 0 &&
          ($window.width() > 536
            ? $('.products').each(function () {
                setButtonHeight($(this).find('.product'));
              })
            : $('.products').each(function () {
                $(this).find('.segment .button').removeAttr('style'),
                  $(this).find('.segment .button span').removeAttr('style');
              })),
        $('.page-tabs').not('.contact-page').length > 0 && reduceTabs(),
        $('.play-video').length > 0 &&
          $('.play-video').on('click', initVideoOverlay),
        $('.announcement-bar').length > 0 &&
          ($header.css('top', $('.announcement-bar').height()),
          $('.close-announcement').on('click', closeAnnouncement)),
        $('.carousel').length > 0 &&
          $('.carousel .rotator').flexslider({
            slideshow: !1,
            animation: 'slide',
            controlNav: 'thumbnails',
            smoothHeight: !0,
            start: function () {
              $('.flex-active')
                .removeClass('flex-active')
                .parent('li')
                .addClass('flex-active');
            },
            after: function () {
              $('.flex-active')
                .removeClass('flex-active')
                .parent('li')
                .addClass('flex-active');
            },
          }),
        $('[data-letter]').length > 0 &&
          ($('.list .group').each(function () {
            $('[data-letter=' + $(this).data('group') + ']').addClass('active');
          }),
          $('.group h4').on('click', scrollToAnchors)),
        $('.pretty-select').length > 0 &&
          $('.pretty-select:visible') &&
          $('.pretty-select').select2({
            minimumResultsForSearch: 1 / 0,
          }),
        $emailField.on('keydown', signUpSubmit),
        $('.has-submenu .sm-trigger').each(function () {
          $(this).on(eventtype, initSubMenu);
        }),
        $('.locations').length > 0 &&
          $('.location h4').on('click', showLocations),
        $('.anchors').length > 0 &&
          $('.anchors a').on('click', function (event) {
            event.preventDefault(),
              '##' == $(this).attr('href') && $(this).attr('href', '#'),
              productAnchors(event);
          }),
        $('.pager li a').unbind('click').click(toTopScrolling),
        $('.to-top').unbind('click').click(toTopScrolling),
        $('.misc.region-switcher').on('click', regionSwitcher),
        $('.region-dropdown ul li').on('click', switchRegions),
        $body.on('click', closeRegionSwitcher),
        $('.filter-set input[type="checkbox"]').length > 0 &&
          $('.filter-set input[type="checkbox"]').change(function () {
            $(this).is(':checked')
              ? ($('.checked-filters').addClass('active'),
                $('.checked-filters ul').append(
                  '<li class="' +
                    $(this).attr('id') +
                    '"><span>' +
                    $(this).next().text() +
                    '</span></li>',
                ))
              : ($('li.' + $(this).attr('id')).remove(),
                $('.checked-filters ul').children().length < 1 &&
                  $('.checked-filters').removeClass('active'));
          }),
        $('input#rbtn3').length > 0 &&
          $('input#rbtn3').change(function () {
            $(this).is(':checked') && $('#ddldepartment3.dropdown').show();
          }),
        $('.filter-set').length > 0 &&
          $('.filter-set h5').on('click', function (e) {
            $(this).toggleClass('active');
            if ($(this).hasClass('active')) {
              $('.refinearrow').attr(
                'src',
                '/McKesson/images/icons/WhiteNavArrowDown.png',
              );
            } else {
              $('.refinearrow').attr(
                'src',
                '/McKesson/images/icons/WhiteNavArrow.png',
              );
            }
            $(this).next().toggleClass('active'),
              $('.pretty-select').length > 0 &&
                $('.pretty-select:hidden') &&
                $('.pretty-select').select2({
                  minimumResultsForSearch: 1 / 0,
                });
          }),
        $('.search-filter-set').length > 0 &&
          $('.trigger-icon').on('click', function (e) {
            e.stopPropagation(),
              $(this).parent().hasClass('active') ||
                ($('.trigger-icon').parent().removeClass('active'),
                $(this).parent().addClass('active'),
                $('.reset').addClass('active'),
                $('.apply, .cancel').addClass('active'),
                $('.apply, .cancel').prop('disabled', !1));
          }),
        $('.filter-sets').length > 0)
      ) {
        $('.filter-sets select').on('select2:open', function (event) {
          setTimeout(function () {
            $('.select2-results__option:first').html('Clear Filter');
          }, 50);
        }),
          $('.filter-sets select').on('change', function () {
            var defaultFilters = !0;
            $('.pretty-select').each(function () {
              $(this).find('option:first-child').val() !=
                $(this).select2('val') && (defaultFilters = !1);
            }),
              defaultFilters
                ? $('.reset.active').removeClass('active')
                : $('.reset').addClass('active');
          });
        var defaultFilters = !0;
        $('.pretty-select').each(function () {
          $(this).find('option:first-child').val() != $(this).select2('val') &&
            (defaultFilters = !1);
        }),
          defaultFilters
            ? $('.reset.active').removeClass('active')
            : $('.reset').addClass('active');
      }
      $document.on('click', '.filters-trigger .label', function () {
        $(this).parent().next().toggleClass('active');
      }),
        $('.reset').length > 0 &&
          ($document.on('click', '.reset.active', function (e) {
            clearFilters(e);
          }),
          $document.on('click', '.remove-filter', function (e) {
            clearFilters(e);
          }),
          $window.width() < 1025
            ? $('.search-filters-container').hasClass('collapsed') ||
              $('.search-filters-container').addClass('collapsed')
            : $document.off(
                'click',
                '.search-filters-container.collapsed .title',
              ),
          $document.on(
            'click',
            '.search-filters-container.collapsed .title',
            function (e) {
              $('.search-filter-set').toggleClass('active');
            },
          )),
        $('.search-results').length > 0 &&
          $window.width() < 1025 &&
          $('.filter-set').each(function () {
            $(this).children('h5').hasClass('active') &&
              $(this).children('.filters').removeClass('active');
          }),
        $('.checked-filters').length > 0 && moveCheckedFilters(),
        $('.checked-filters').length > 0 &&
          $('.checked-filters').on('click', 'li', filterCheck),
        $('.product-listing.grid').length > 0 &&
          $('.product-listing.grid').is(':visible') &&
          $('.product-listing.grid .list').masonry({
            itemSelector: '.group',
            columnWidth: function (containerWidth) {
              return containerWidth / 3;
            },
            isAnimated: !0,
            layoutPriorities: {
              shelfOrder: 4,
            },
          }),
        $('.office-locations').length > 0 &&
          $('.office-locations').is(':visible') &&
          $('.locations').each(function () {
            $(this).masonry({
              itemSelector: '.location',
              columnWidth: function (containerWidth) {
                return containerWidth / 2;
              },
              isAnimated: !0,
              layoutPriorities: {
                shelfOrder: 4,
              },
            });
          }),
        $('.login-featured').length > 0 &&
          ($('.results-inner').masonry({
            itemSelector: '.category',
            percentPosition: !0,
            horizontalOrder: !0,
          }),
          $(
            '#primary-bar #functions .results-wrapper#browse-results .results .results-inner, .primary-bar__nav .results-wrapper .results .results-inner',
          ).attr('style', '')),
        $.trim($('section.page-resources').text()).length <= 0
          ? $('section.page-resources').remove()
          : $('section.page-resources .resources .resource').each(function () {
              $(this).text().trim().length <= 0 && $(this).remove();
            }),
        $('#design_content, div.design_content').css({
          padding: '0',
          'background-color': 'transparent',
        }),
        $(
          '#primary-bar #functions .results-wrapper#browse-results .results .results-inner .list li .sub-menu .extra ul, .primary-bar__nav .results-wrapper .results .results-inner .list li .sub-menu .extra ul',
        ).each(function () {
          $(this).text().length <= 0 && $(this).remove();
        }),
        $('#browse-bar .browse-tab, .browse-bar .browse-tab')
          .last()
          .find('.results-wrapper')
          .addClass('last-item'),
        $('.form').length > 0 &&
          ($('input').each(function () {
            $(this).on('keydown', function (e) {
              if (
                13 === (code = e.keyCode || e.which) &&
                (e.preventDefault(),
                e.stopPropagation(),
                'text' === $(this).attr('type') && validateName($(this)[0]),
                'email' === $(this).attr('type') && validateEmail($(this)[0]),
                $('#comment').each(function () {
                  validateComment($(this)[0]);
                }),
                $('.field-row .field').hasClass('has-error'))
              )
                return !1;
            });
          }),
          $('.form .submit-button button').on('click', function (e) {
            if (
              (e.preventDefault(),
              e.stopPropagation(),
              'Select' === $('.select2-selection__rendered').text()
                ? $('.select2').parent().addClass('has-error')
                : $('.select2').parent().removeClass('has-error'),
              $('.form input').each(function () {
                'text' === $(this).attr('type') && validateName($(this)[0]),
                  'email' === $(this).attr('type') && validateEmail($(this)[0]);
              }),
              $('#comment').each(function () {
                validateComment($(this)[0]);
              }),
              $('.field-row .field').hasClass('has-error'))
            )
              return !1;
          })),
        $('input.signup').length > 0 &&
          ($('input.signup').on('keydown', function (e) {
            if (
              13 === (code = e.keyCode || e.which) &&
              (e.preventDefault(),
              e.stopPropagation(),
              validateEmail(this),
              $('.sign-up .fields').hasClass('has-error'))
            )
              return !1;
          }),
          $('.sign-up .fields button').on('click', function () {
            if (
              (validateEmail($('input.signup')[0]),
              $('.sign-up .fields').hasClass('has-error'))
            )
              return !1;
          })),
        $('.personalized').length > 0 &&
          $('.segments .wrapper .section-intro .title').css({
            clear: 'both',
            'padding-top': '30px',
          }),
        $('.sign-up').on('click', '.close-error', closeError),
        $('.form-wrapper')
          .on('click', '.close-error', closeError)
          .on('click', '.reset-form', resetForm),
        renderContactEmbedded(),
        $('.floating-filter').on('click', showFilterModal),
        $('.modal-filter .filter-list').on('click', selectFilterOfModalFilter),
        $('.modal-filter .actions .apply').on('click', doneFilterOfModalFilter),
        $('.modal-filter .actions .cancel').on(
          'click',
          clearFilterOfModalFilter,
        ),
        'function' != typeof abTest || abTestExecuted || abTest(),
        $('.filtered-by').length > 0 &&
          $window.width() < 1025 &&
          $document.on('click', '.filtered-by .remove-filter', function (e) {
            removeFilter(e);
          }),
          
        $document.on('click', '.filtered-by .remove-filter', function (e) {
          $('.reset').click();
        }),
        typeof iFrameResize !== 'undefined' &&
          iFrameResize({
            checkOrigin: !1,
            warningTimeout: 0,
            heightCalculationMethod: 'lowestElement',
          }),
        subscribeToFeeds(),
        addURLtoQualtricsSurvey();

      var ua = window.navigator.userAgent,
        iOS =
          !!ua.match(/iPad/i) ||
          !!ua.match(/iPhone/i) ||
          ('MacIntel' === navigator.platform && navigator.maxTouchPoints > 1),
        webkit = !!ua.match(/WebKit/i);
      !0 === (iOS && webkit && !ua.match(/CriOS/i)) &&
        $('#homezone1').length > 0 &&
        setTimeout(adjustPersonalizedHeroHeight(), 300);
    }

    var $this,
      str,
      code,
      hasImage,
      resizeTimer,
      tweetTxt,
      offset,
      patternMenu,
      filters,
      $scrollTop,
      $document = $(document),
      closingClass = 'closing',
      activeClass = 'active',
      stickyClass = ($('.video-overlay .close-video').height(), 'sticky'),
      videoOverlay = '.video-overlay',
      product = '.products .product a, .products .product div',
      article = '.articles .article a',
      $lastWidth = $window.width(),
      $backToTop = $('.to-top'),
      $body = $('body'),
      $header = $('.header'),
      $emailField = $('#signup-field'),
      $showBrowseTriggerText = $('#browse .trigger .browse'),
      $hideBrowseTriggerText = $('#browse .trigger .hide'),
      isMobile = mobilecheck(),
      eventtype = mobilecheck() ? 'touchstart' : 'click',
      sections = $(
        'section:not(.section.promo-block):not(.contact-embedded):not(.breadcrumb):not(.feed):not(.social-footer):not(.hero):not(.links-listing):not(.no-bottom-padding):not(.no-padding):not(.visual-split-list):not(.video-hub-split)',
      );
    if (
      (sections.each(function (i) {
        var nextSection = $(sections.get(i + 1)),
          this_bkg = $(this).css('background-color'),
          next_bkg = nextSection.css('background-color'),
          this_imgbkg = $(this).css('background-image'),
          next_imgbkg = nextSection.css('background-image'),
          gateway = nextSection.parents('.gateway').length > 0;

        this_bkg !== next_bkg ||
          'none' !== this_imgbkg ||
          $(this).hasClass('has-image') ||
          nextSection.hasClass('main-content') ||
          nextSection.hasClass('has-image') ||
          !1 !== gateway ||
          ('none' === next_imgbkg &&
            (parseInt(nextSection.css('padding-top')) > 0
              ? nextSection.css('padding-top', '0')
              : nextSection.css('margin-top', '-50px')));
      }),
      cleanFooterLinks(eventtype),
      $('.page-footer__links-groups').on(
        'click',
        '.footer-section nav',
        toggleMenu,
      ),
      $('.accordion').on(eventtype, '.toggle', toggleAccordion),

      $window
        .on('scroll', windowScroll)
        .on('resize', windowResize)
                .on('load resize', windowLoadResize),
            GatewayHeroContent(),
      centerHeroContent(),
      adjustPersonalizedHeroHeight(),
      initializeTapToCall(),
      hideFilterPopupWhenClickOutside(),
      moveModalFilterToMainContainer(),
      $('.st-menu ul li').length < 1)
    ) {
      var items = $('.navbar-collapse ul').html();
      $('.st-menu ul').html(items);
    }
    window.location.href.indexOf('?aliId=') >= 0 &&
      $('.marketo-container').removeClass('hidden'),
      $('body.our-stories').length > 0 && initialEllipsis(),
      $('.section.visual-split-list').length > 1 &&
        $('.section.visual-split-list').each(function () {
          $(this).next().hasClass('visual-split-list') &&
            $('<hr>').insertAfter(this);
        }),
      $(documentReady);
  })(jQuery, window, document);

var mobile_break = 0,
  break_point = 60,
  reduce_point = 46,
  reduce_margin = 0,
  two_lines_break = 0,
  bkg_size,
  icon = $('.intro-and-tabs input').val();
$('.page-tab').each(function () {
  break_point += $(this).outerWidth();
}),
  $('.hoverImg').length > 0 &&
    ($('.hoverImg').attr('tabindex', 0),
    $('.hoverImg').on('focus', function () {
      $(this).css('transform', 'scale(1.8)');
    }),
    $('.hoverImg').on('focusout', function () {
      $(this).css('transform', 'scale(1)');
    }));
var arrangeTimer = setInterval(function () {
    $('#sayt-view').length > 0 && arrangeSearch();
  }, 100),
  elem = $('.table-wrapper'),
  inner = $('.table-wrapper div'),
  inner_width;
(inner_width =
  inner.length > 0
    ? inner.width() * inner.length
    : $('.table-wrapper table').width()),
  elem.scroll(function () {
    parseInt(elem.scrollLeft()) + parseInt(elem.width()) >= inner_width
      ? elem.addClass('no-mask')
      : elem.hasClass('no-mask') && elem.removeClass('no-mask');
  }),
  $('.open-register').on('click', function () {
    $('.marketo-container.hidden').removeClass('hidden');
  });

function getParameterByName(name, url) {
  url || (url = window.location.href);
  let newName = name.replace(/[\[\]]/g, '\\$&');
  let regex = new RegExp('[?&]' + newName + '(=([^&#]*)|&|#|$)');
  let results = regex.exec(url);
  return results
    ? results[2]
      ? decodeURIComponent(results[2].replace(/\+/g, ' '))
      : ''
    : null;
}

!(function ($, window, document) {
  'use strict';

  function mobilecheck() {
    var check = !1;
    return ((function(aa) {
        (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(aa) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(aa.substr(0, 4))) && (check = !0);
      }
    )(navigator.userAgent || navigator.vendor || window.opera),
      check);
  }

  function clearSearch() {
    setTimeout(function () {
      $searchResultsContainer.removeClass(activeClass),
        $initLiveSearchValue.parent().hide(),
        $searchResults.hide().removeClass(activeClass),
        $clearSearchButton.removeClass(activeClass),
        $initLiveSearchValue.text(''),
        $searchInput.val(''),
        $searchInput.blur(),
        $('#search-field').attr('aria-expanded', 'false'),
        $('#search-status').text(''),
        $('#sayt-view').removeAttr('style'),
        $('#sayt-keywords').html(''),
        $('#sayt-links').html('');
    }, 1000);
  }

  function hideSearch() {
    const re = /^\s+$/i;
    $searchInput.val().length >= minSearchChars
      ? re.test($searchInput.val()) && clearSearch()
      : clearSearch(),
      $searchResultsContainer.removeClass(activeClass),
      $searchResults.hide().removeClass(activeClass),
      $navWrapper.removeClass(activeSearch).addClass(closingSearch),
      $searchInput.blur(),
      setTimeout(function () {
        $navWrapper.removeClass(closingSearch);
      }, 500);
  }

  function hideSearchResults() {
    $initLiveSearchValue.parent().show(),
      $searchResults.hide().removeClass(activeClass),
      (activeResult = -1),
      (isResult = !1),
      $('#search-field').attr('aria-expanded', 'false'),
      $('#search-status').text(''),
      $('.sayt-container').length >= 1
        ? $('.sayt-list .sayt-list-element').removeClass('selected')
        : $('.result').removeClass('selected');
  }

  function resetSearch() {
    setTimeout(function () {
      var re = /^\s+$/i;

      $navWrapper.removeClass(activeSearch),
        $('#search-field').attr('aria-expanded', 'false'),
        $('#search-status').text(''),
        $('#search-field').val(''),
        $("label[for='search-field']").removeAttr('style'),
        $searchInput.val().length >= minSearchChars
          ? re.test($searchInput.val()) && clearSearch()
          : clearSearch(),
        $searchInput.blur();
    }, 1000);
  }

  function initSearchResults() {
    $searchResults.show().addClass(activeClass);
    $(searchField).css('padding', '0 32px 0 0');
    isResult = true;
  }

  function initClearSearch() {
    $clearSearchButton.addClass(activeClass);
    $searchResultsContainer.addClass(activeClass);
  }

  function initSearch() {
    $functionsWrapper.hasClass(activeBrowse) && hideBrowse(),
      $navWrapper.addClass(activeSearch),
      $searchInput.focus(),
      $searchInput.val().length >= minSearchChars &&
        (initSearchResults(), initClearSearch());
  }

  function initAccesibleSearch() {
    $functionsWrapper.hasClass(activeBrowse) && hideBrowse(),
      $navWrapper.addClass(activeSearch),
      $searchInput.val().length >= minSearchChars &&
        (initSearchResults(), initClearSearch());
  }

  function submitSearch() {
    window.location.href =
      '/Search/?term=' + document.getElementById('search-field').value;
  }

  function initializeSearch(e) {
    if (touchmoved === true) return;
    'clear-search' === e.target.id
      ? (clearSearch(), $searchInput.blur())
      : 'search' !== e.target.id &&
        ($clearSearchButton.removeClass(activeClass),
        $(searchField).css('padding', '0 0 0 0'));

    $(e.target).hasClass('browse') || $(e.target).hasClass('trigger')
      ? ($('.trigger')
          .find('img')
          .attr('src', '/McKesson/images/arrows/nav-right-arrow.png'),
        $(e.target).parents('.browse-tab').hasClass(activeBrowse)
          ? hideBrowse()
          : (hideBrowse(),
            initBrowse($(e.target).parents('.browse-tab').attr('id')),
            $(e.target)
              .parent()
              .find('img.browse')
              .attr('src', '/McKesson/images/arrows/nav-right-arrow.png')))
      : 0 === $(e.target).parents('#browse-results').length &&
        ($('.trigger')
          .find('img')
          .attr('src', '/McKesson/images/arrows/nav-right-arrow.png'),
        hideBrowse()),
      $navWrapper.hasClass(activeSearch)
        ? $(e.target).hasClass(autocompleteListItem) ||
          'search-field' === e.target.id ||
          '#search' === e.target.parentNode ||
          ('search-button' !== e.target.id
            ? resetSearch()
            : $searchInput.val().length >= minSearchChars
              ? submitSearch()
              : $searchInput.focus(),
          ('result' !== e.target.className &&
            'search-val' !== e.target.className &&
            'sayt-container-1' !== e.target.className &&
            'category' !== e.target.className) ||
            ($(e.target).addClass('selected'),
            $('.sayt-container').length >= 1
              ? $searchInput.val(
                  $(e.target).children('.sayt-list .sayt-list-element').text(),
                )
              : $searchInput.val($(e.target).children('.search-val').text()),
            submitSearch()))
        : 'search-field' !== e.target.id && '#search' !== e.target.parentNode
          ? 'search-button' === e.target.id && initSearch()
          : initSearch();
  }

  var code,
    $searchVal,
    touchmoved,
    $window = $(window),
    isResult = !1,
    activeResult = -1,
    activeClass = 'active',
    activeSearch = 'search-active',
    activeBrowse = 'browse-active',
    closingSearch = 'search-closing',
    closingBrowse = 'browse-closing',
    clearSearchTriggerID = '#clear-search',
    autocompleteListItem = 'sayt-list-element',
    searchField = '#search-field',
    $clearSearchButton = $(clearSearchTriggerID),
    $searchInput = $(searchField),
    $body = $('body'),
    $browseSubmenu = $('.results-inner .list li.has-submenu'),
    $functionsWrapper = $('#functions, .primary-bar__nav'),
    $navWrapper = $('#navbar, .page-navbar-top'),
    $searchResultsContainer = ($('#search'), $('#search-results')),
    $initLiveSearchValue = $('#search-results .init-search-val .search-val'),
    $searchResults = $('#search-results .results-container'),
    $searchResultsValue = $('#search-results .results-container .search-val'),
    eventtype = mobilecheck() ? 'touchend' : 'click',
    minSearchChars = 2;

  $('.sayt-container').length >= 1 &&
    ($searchResultsContainer = $('#sayt-view')),
    (window.hideBrowse = function () {
      $browseSubmenu.removeClass(activeClass),
        $functionsWrapper
          .find('.' + activeBrowse)
          .removeClass(activeBrowse)
          .addClass(closingBrowse);
      if (window.innerWidth < 838) {
        $('.brand').removeClass('hideblueimage'),
          $('#whitelogo').hide(),
          $('#functions').removeClass('navyactive'),
          $('#mck-nav-modal').hide(),
          $('a').unbind('click');
      }
      setTimeout(function () {
        $functionsWrapper.find('.' + closingBrowse).removeClass(closingBrowse);
      }, 500);
      $('.section-intro.search-page.browse-active').length > 0 &&
        $('.section-intro.search-page.browse-active').removeClass(
          'browse-active',
        );
    }),
    (window.initBrowse = function (browseID) {
      if (window.innerWidth < 838 && browseID == 'browse-tab0') {
        $('.brand').toggleClass('hideblueimage'),
          $('#whitelogo').toggle(),
          $('#mck-nav-modal').toggle();
      }
      $navWrapper.hasClass(activeSearch) && hideSearch(),
        $('#' + browseID).addClass(activeBrowse),
        $window.width() < 975 &&
          $('.section-intro.search-page').length > 0 &&
          $('.section-intro.search-page').addClass('browse-active');
    }),
    $body
      .on('focusin', '.sayt-list-element span', function () {
        $('.sayt-list-element').removeClass('selected'),
          $(this).parent().addClass('selected'),
          $('#search-field').val($(this).text());
      })
      .on('focusout', '.sayt-list-element span', function () {})
      .on('keydown', '.sayt-list-element span', function (e) {
        13 === (code = e.keyCode || e.which) && submitSearch();
      }),
    $body
      .on(eventtype, initializeSearch)
      .on('touchmove', function () {
        touchmoved = !0;
      })
      .on('touchstart', function () {
        touchmoved = !1;
      }),
    $('#search-field').on('focus', function () {
      initAccesibleSearch();
    }),
    $searchInput.on('focusout', function () {}),
    $searchInput.on('focus', function () {
      $("label[for='search-field']").css('opacity', '0'),
        '' === $('#search-field').val() &&
          ((isResult = !1),
          $('#sayt-view').removeAttr('style'),
          $('#sayt-keywords').html(''),
          $('#sayt-links').html(''));
    }),
    $searchInput
      .on('input', function () {
        let str, re, newStr, pattern;
        $searchVal = $(this).val();
        $initLiveSearchValue.text($searchVal);
        re = /^\s+$/i;

        re.test($searchVal) ||
          ($initLiveSearchValue.parent().is(':visible') ||
            $initLiveSearchValue.parent().show(),
          $searchVal && $searchVal.length >= minSearchChars
            ? ($initLiveSearchValue.parent().is(':visible') &&
                $initLiveSearchValue.parent().hide(),
              $searchResults.hasClass(activeClass) || initSearchResults(),
              (pattern = $searchVal),
              (pattern = pattern
                .replace(/\s+/gi, '|')
                .replace(/^\|+/g, '')
                .replace(/\|+$/g, '')),
              (re = new RegExp('(' + pattern + ')', 'gi')),
              $searchResultsValue.each(function () {
                (str = $(this).text()),
                  (newStr = str.match(re)
                    ? str.replace(re, '<strong>$&</strong>')
                    : str),
                  $(this).html(newStr);
              }))
            : $searchResults.hasClass(activeClass) && hideSearchResults(),
          $searchInput.val().length >= 1 &&
            ($searchResultsContainer.addClass(activeClass),
            $clearSearchButton.hasClass(activeClass) ||
              $clearSearchButton.addClass(activeClass)));
      })
      .on('keyup', function (e) {
        (code = e.keyCode || e.which),
          isResult &&
            $searchVal &&
            $searchVal.length <= 1 &&
            $clearSearchButton.removeClass(activeClass);
      })
      .on('keydown', function (e) {
        (code = e.keyCode || e.which),
          13 === code &&
            (e.preventDefault(),
            $searchInput.val().length >= minSearchChars
              ? submitSearch()
              : $searchInput.focus()),
          8 === code &&
            $searchVal &&
            $searchVal.length <= 1 &&
            $('.clear-search').removeClass('active'),
          27 === code &&
            ($('.clear-search').removeClass('active'),
            clearSearch(),
            hideSearch(),
            $('#sayt-view').removeAttr('style'),
            $('#sayt-keywords').html(''),
            $('#sayt-links').html(''));
      });
})(jQuery, window, document),
    $(document).ready(function () {
        setTimeout(function () {
            $("#mck-nav-modal").hide();
            $("#mck-nav-modal").removeClass("show");
            $('#functions').find('.browse-tab.single').each(function () {

                var hrefstring = $(this).find(".browse").text().trim().replaceAll(" ", "");
                $(this).find('a').each(function () {
                    var idstring = "";
                    var textstring = $(this).text();
                    hrefstring = hrefstring.split("/", 2).join("/");
                    //hrefstring = hrefstring.substring(1, hrefstring.length);
                    idstring = hrefstring.replaceAll('-', '') + '-' + textstring.replaceAll(/\s/g, '').replaceAll('-', '');
                    idstring = idstring.replaceAll("<br/>", "").replaceAll(/&/g, "");
                    $(this).attr('id', idstring);
                })
            });
        }, 250);
    var searchstring = getParameterByName('q');
    null === searchstring && (searchstring = ''),
      $('#search-field').val(searchstring),
      targetsettings.getSettings().always(function () {
        $('#search-field').TargetComplete(targetsettings);
      });
  });
var __global_counter = {},
  WSCS = {
    data: null,
    setHtml: function (name, data) {
      this.data = data;
    },
    getHtml: function () {
      return this.data;
    },
    log: function (str) {
      'undefined' != typeof console &&
        'undefined' !== console.log &&
        console.log(str);
    },
  },
  keyupEventType = 'keyup',
  keydownEventType = 'keydown',
  touchAction = '',
  pluginName = 'TargetComplete',
  dataKey = 'plugin_' + pluginName,
  CacheManager = function () {
    return {
      Cs: [],
      options: {
        id: '_global',
      },
      init: function (ids) {
        var o = this;
        $.each(ids, function (i, val) {
          o.setCache(val);
        });
      },
      getId: function (id) {
        return void 0 !== id ? id : this.options.id;
      },
      getData: function (id, query) {
        var o = this;
        return (
          (id = o.getId(id)), this.check(id, query) ? o.Cs[id][query].d : null
        );
      },
      setCache: function (id) {
        var o = this;
        (id = o.getId(id)), (o.Cs[id] = {});
      },
      add: function (id, query, ops) {
        var o = this;
        return !(!o.Cs.length || !o.Cs[id]) && ((o.Cs[id][query] = ops), !0);
      },
      clear: function (id, query) {
        var o = this;
        o.Cs[id] && o.Cs[id][query] && (o.Cs[id][query] = {});
      },
      clearAll: function (id) {
        var o = this;
        o.Cs.length && o.Cs[id] && (o.Cs[id] = {});
      },
      check: function (id, query) {
        var o = this;
        return (
          id && o.Cs[id] && o.Cs[id][query] && void 0 !== o.Cs[id][query].d
        );
      },
    };
  },
  TargetPlugin = function (element, options) {
    (this.cache = new CacheManager()),
      (this.inputElement = element),
      (this.viewElement = null),
      (this._now = 0),
      (this._before = 0),
      (this._keytimer = 0),
      (this.options = {
        viewId: 'sayt-view',
        formBrowserAutocomplete: !1,
        formId: '',
        formName: '',
        fade: !1,
        layoutRows: 1,
        layoutColumns: 1,
        secondsToOpen: 0,
        secondsToClose: 0,
        minInputLength: 2,
        minInputDelay: 50,
        minWidth: null,
        minHeight: null,
        useMinMax: !1,
        heightUnit: 'px',
        widthUnit: 'px',
        arrowKeys: !0,
        submitOnSelect: !1,
        createViewElement: !0,
        adjustHeightChildren: [],
        adjustWidthChildren: [],
        resizeThrottle: 70,
        defaultCSSWidth: {
          width: 'auto',
        },
        defaultCSSHeight: {
          height: 'auto',
        },
        adjustHeightOnResize: !1,
        adjustWidthOnResize: !1,
        displayCSSHide: {
          display: 'none',
        },
        displayCSSShow: {
          display: 'block',
        },
        onAdjustHeight: function (height, css) {
          return !0;
        },
        onAdjustWidth: function (width, css) {
          return !0;
        },
        onSelect: function (frm, query, href) {},
        containers: [],
      }),
      this.init(options);
  };
Date.now ||
  (Date.now = function () {
    return Number(new Date());
  }),
  (function ($, w, d, undefined) {
    ($.fn.highlight = function (str, className) {
      var regex = new RegExp(str, 'gi');
      return this.each(function () {
        $(this)
          .contents()
          .filter(function () {
            return 3 === this.nodeType;
          })
          .replaceWith(function () {
            return (this.nodeValue || '').replace(regex, function (match) {
              return '<span class="' + className + '">' + match + '</span>';
            });
          });
      });
    }),
      (TargetPlugin.prototype = {
        init: function (options) {
          var o = this;
          $.extend(o.options, options),
            o.options.createViewElement &&
              o.inputElement.after('<div id="' + o.options.viewId + '"></div>'),
            (o.viewElement = $('#' + o.options.viewId)),
            o.options.fade && $('#' + o.options.viewId).css('opacity', '0'),
            o.options.formBrowserAutocomplete ||
              o.getFormElement().attr('autocomplete', 'off'),
            o.bindEvents();
          var i = 1,
            keys = [];
          $(o.options.containers).each(function () {
            var container = this,
              myid = container.id ? 'id="' + container.id + '"' : '',
              myclass = container.className ? container.className : '',
              me = $(
                '.sayt-container[data-sayt-container="' +
                  container.index +
                  '"]',
              );
            (container.index = i),
              me.length !== 0
                ? (container.id && me.attr('id', container.id),
                  myclass && me.addClass(myclass),
                  me.addClass('sayt-container-' + container.index))
                : o.viewElement.append(
                    '<div ' +
                      myid +
                      ' class="sayt-container sayt-container-' +
                      container.index +
                      ' ' +
                      myclass +
                      '" data-sayt-container="' +
                      container.index +
                      '"></div>',
                  ),
              keys.push(container.index),
              i++;
          }),
            o.cache.init(keys);
        },
        getFormElement: function () {
          var o = this;
          return o.options.formId
            ? $('#' + o.options.formId)
            : this.options.formName
              ? $('form[name=' + o.options.formName + ']')
              : $(o.inputElement).closest('form');
        },
        bindEvents: function () {
          function resizeThrottler() {
            resizeTimeout ||
              (resizeTimeout = setTimeout(function () {
                (resizeTimeout = null), adjust();
              }, o.options.resizeThrottle));
          }

          function adjust() {
            o.options.adjustHeightOnResize && o.adjustHeight(),
              o.options.adjustWidthOnResize && o.adjustWidth();
          }

          var o = this,
            addEvent = function (object, type, callback) {
              null !== object &&
                void 0 !== object &&
                (object.addEventListener
                  ? object.addEventListener(type, callback, !1)
                  : object.attachEvent
                    ? object.attachEvent('on' + type, callback)
                    : (object['on' + type] = callback));
            },
            el = o.inputElement.length ? o.inputElement[0] : null;
          let __requests = 0;
          addEvent(el, keyupEventType, function (event) {
            var query = o.getInputElementQuery(),
              key = event.keyCode + '';
            (o._now = Date.now()),
              (o._before = o._before ? o._before : o._now),
              clearTimeout(o._keytimer),
              key.match(/(27|33|34|38|40)/) ||
                ($('.sayt-on').removeClass('sayt-on'),
                o.options.minInputDelay &&
                o._now - o._before >= o.options.minInputDelay
                  ? query &&
                    query.length >= o.options.minInputLength &&
                    (o.request(), __requests++)
                  : o.options.minInputDelay && o._now !== o._before
                    ? o.options.minInputDelay &&
                      (o._keytimer = setTimeout(function () {
                        query &&
                          query.length >= o.options.minInputLength &&
                          (o.request(), __requests++),
                          (o._before = o._now);
                      }, o.options.minInputDelay))
                    : query &&
                      query.length >= o.options.minInputLength &&
                      (o.request(), __requests++));
          }),
            addEvent(el, 'blur', function (ev) {
              o.blur();
            }),
            addEvent(el, 'focus', function (ev) {
              o.focus();
            }),
            addEvent(el, keydownEventType, function (event) {
              switch (event.keyCode) {
                case 27:
                  o.close();
                  break;
                case 33:
                  o.scrollUp();
                  break;
                case 34:
                  o.scrollDown();
                  break;
                case 37:
                  break;
                case 38:
                  o.scrollUp();
                  break;
                case 39:
                  break;
                case 40:
                  o.scrollDown();
                  break;
                case 13:
                  o.go();
              }
            });
          var resizeTimeout;
          (o.options.adjustHeightOnResize || o.options.adjustWidthOnResize) &&
            addEvent(window, 'resize', resizeThrottler);
        },
        render: function (container, datayext, query) {
          var data = [];
          if (datayext != null) {
            for (var i = 0; i < datayext.response.results.length; i++) {
              data.push(datayext.response.results[i].value);
            }
          }
          var o = this;
          container &&
            ('autocomplete' === container.containerType ||
            'array' === container.containerType
              ? o.renderArray(container, data, query)
              : 'WSCS' === container.containerType && WSCS
                ? ((data = WSCS.getHtml()),
                  o.renderHtml(container, data, query))
                : 'html' === container.containerType && container.requestUrl
                  ? o.renderHtml(container, data, query)
                  : ('html' !== container.containerType &&
                      'array' !== container.containerType) ||
                    container.requestUrl ||
                    !container.content ||
                    o.renderHtml(container, container.content, query)),
            $('#sayt-links .sayt-list-element').length > 0 ||
            $('#sayt-keywords .sayt-list-element').length > 0
              ? (o.open(),
                $('#sayt-list').attr('role', 'listbox'),
                $('.sayt-list-element').attr('role', 'option'),
                $('#navbar').hasClass('search-active')
                  ? $('#search-field').attr('aria-expanded', 'true')
                  : $('#search-field').attr('aria-expanded', 'false'),
                $('#search-status').text(
                  $('.sayt-list-element').length +
                    ' results are available, use up and down arrow keys to navigate',
                ))
              : o.close();
        },
        renderArray: function (container, data, query) {
          var o = this,
            html = '',
            mycontainer = $(
              '.sayt-container[data-sayt-container="' + container.index + '"]',
            );
          if ('function' == typeof container.onRender)
            html = container.onRender(data, query);
          else {
            container.maxResults = container.maxResults
              ? container.maxResults
              : 0;
            data.length > 0
              ? ((html = ''),
                $(data).each(function (i, val) {
                  i < container.maxResults &&
                    o.isMatch(container, val, query) &&
                    (html +=
                      '<li class="sayt-list-element" data-sayt-value="' +
                      val +
                      '" role="option"><span tabindex="0">' +
                      val +
                      '</span></li>'),
                    i++;
                }),
                (html = html
                  ? '<div><ul class="sayt-list" role="listbox">' +
                    html +
                    '</ul></div>'
                  : ''))
              : (html = '');
          }
          mycontainer.length !== 0 &&
            (container.highlightWords && (html = o.highlightHtml(html, query)),
            mycontainer.html(html),
            mycontainer.find('.sayt-list-element').each(function (i, obj) {
              $(obj).bind('touchstart', function (ev) {
                touchAction = 'touchstart';
              }),
                $(obj).bind('touchmove', function (ev) {
                  touchAction = 'touchmove';
                }),
                $(obj).bind('touchend', function (ev) {
                  'touchmove' !== touchAction &&
                    ($('.sayt-on').removeClass('sayt-on'),
                    $(obj).addClass('sayt-on'),
                    $(obj).find('.sayt-link').length !== 0 ||
                      o.inputElement.val($(obj).attr('data-sayt-value')),
                    o.go()),
                    (touchAction = '');
                }),
                $(obj).bind('click', function (ev) {
                  $(obj).find('.sayt-link').length !== 0 ||
                    ($('.sayt-on').removeClass('sayt-on'),
                    $(obj).addClass('sayt-on'),
                    o.inputElement.val($(obj).attr('data-sayt-value'))),
                    o.go();
                }),
                $(obj).bind('mouseover', function (ev) {
                  $('.sayt-on').removeClass('sayt-on'),
                    $(obj).addClass('sayt-on');
                }),
                $(obj).bind('mouseout', function (ev) {
                  $('.sayt-on').removeClass('sayt-on');
                });
            }));
        },
        renderHtml: function (container, html, query) {
          var o = this,
            mycontainer = $(
              '.sayt-container[data-sayt-container="' + container.index + '"]',
            );
          'function' == typeof container.onRender &&
            (html = container.onRender(data)),
            mycontainer.length !== 0 &&
              html &&
              (container.highlightWords &&
                (html = o.highlightHtml(html, query)),
              mycontainer.html(html),
              mycontainer.find('.sayt-list-element').each(function (i, obj) {
                $(obj).bind('touchstart', function (ev) {
                  touchAction = 'touchstart';
                }),
                  $(obj).bind('touchmove', function (ev) {
                    touchAction = 'touchmove';
                  }),
                  $(obj).bind('touchend', function (ev) {
                    'touchmove' !== touchAction &&
                      ($('.sayt-on').removeClass('sayt-on'),
                      $(obj).addClass('sayt-on'),
                      o.go()),
                      (touchAction = '');
                  }),
                  $(obj).bind('mouseover', function (ev) {
                    $('.sayt-on').removeClass('sayt-on'),
                      $(obj).addClass('sayt-on');
                  }),
                  $(obj).bind('mouseout', function (ev) {
                    $('.sayt-on').removeClass('sayt-on');
                  }),
                  $(obj).bind('click', function (ev) {
                    $('.sayt-on').removeClass('sayt-on'),
                      $(obj).addClass('sayt-on'),
                      o.go();
                  });
              }));
        },
        focus: function () {
          var o = this,
            query = o.getInputElementQuery();
          query &&
            query.length >= o.options.minInputLength &&
            query !== o.options.emptyInputValue &&
            ($('#sayt-links .sayt-list-element').length > 0 ||
              $('#sayt-keywords .sayt-list-element').length > 0) &&
            o.open();
        },
        blur: function () {
          $('.sayt-on').length;
        },
        request: function () {
          var o = this,
            i = 1;
          $(this.options.containers).each(function () {
            this.requestUrl =
              'https://liveapi.yext.com/v2/accounts/me/answers/autocomplete?api_key=54d95e3acf60def2fb1e2b5acadab75f&v=20180204&experienceKey=mckesson-answers&input=' +
              $('#search-field').val().replace('#', '');
            var container = this,
              query = o.getInputElementQuery(),
              ajaxsettings = {
                dataType: container.ajaxDataType,
                url:
                  'https://liveapi.yext.com/v2/accounts/me/answers/autocomplete?api_key=54d95e3acf60def2fb1e2b5acadab75f&v=20180204&experienceKey=mckesson-answers&input=' +
                  $('#search-field').val().replace('#', ''),
                success: function (data) {
                  if (data != null) {
                    $('#sayt-keywords').html('');
                    var htmlstringloop = '';
                    var phtmlstring = '';
                    var leftcounter = 0;
                    var rightcounter = 0;
                    htmlstringloop +=
                      '<div class="sayt-keywords-heading1">Search Suggestions</div>';
                    htmlstringloop +=
                      '<ul id="leftlist" class="sayt-list" role="listbox">';
                    for (var i = 0; i < data.response.results.length; i++) {
                      var name = data.response.results[i].value.replace(
                        '<script>',
                        '',
                      );
                      name = name.replace('</script>', '');
                      name = name.replace('alert', '');
                      if (data.response.results[i].verticalKeys.length == 0) {
                        leftcounter = leftcounter + 1;
                        if (leftcounter <= 5) {
                          htmlstringloop +=
                            '<li class="sayt-list-element" role="option"><span class="component-a"><a href="/Search/?term=' +
                            name +
                            '">' +
                            name +
                            '</a></span></li>';
                        }
                      } else {
                        rightcounter = rightcounter + 1;
                        if (rightcounter <= 5) {
                          phtmlstring +=
                            '<p class="sayt-list-element" role="option"><a href="/Search/?term=' +
                            name +
                            '" class="sayt-link">' +
                            name +
                            '</a></p>';
                        }
                      }
                    }
                    htmlstringloop += '</ul>';
                    htmlstringloop += '</div>';
                    var rightloopstring = '';
                    rightloopstring +=
                      '<div class="saytheading1">Related Results</div>';
                    rightloopstring += '<div id="sayt-list" role="listbox">';
                    rightloopstring += phtmlstring;
                    rightloopstring += '</div>';
                    $('#sayt-keywords').html(htmlstringloop);
                    $('#sayt-links').html(rightloopstring);
                    $('#sayt-keywords').show();
                    $('#sayt-links').show();
                    $('#sayt-view').show();
                    if (data.response.results.length > 0) {
                      $('#sayt-view').show();
                    } else {
                      $('#sayt-view').hide();
                    }
                  }
                },
              };
            $.ajax(ajaxsettings);
            i++;
          });
        },
        getInputElementQuery: function () {
          return this.inputElement.val();
        },
        getRequestURL: function (container) {
          var req = '',
            term = this.getInputElementQuery(),
            t = container.prependToQuery
              ? container.prependToQuery + term
              : term;
          if (
            ((req =
              'autocomplete' === container.containerType
                ? this.getAutocompleteRequest(container)
                : container.requestUrl),
            (t = container.appendToQuery ? t + container.appendToQuery : t),
            req)
          ) {
            var sep = container.queryParamSeparator
              ? container.queryParamSeparator
              : req.match(/\?/)
                ? '&'
                : '?';
            (sep = '&' === sep && req.match(/\?\w/) ? '&' : ''),
              (req = container.queryParam
                ? req + sep + container.queryParam + '=' + t
                : req);
          }
          return (
            'https://liveapi.yext.com/v2/accounts/me/answers/autocomplete?api_key=54d95e3acf60def2fb1e2b5acadab75f&v=20180204&experienceKey=mckesson-answers&input=' +
            t
          );
        },
        getAutocompleteRequest: function (container) {
          var i,
            protocol = 'https:' === d.location.protocol ? 'https:' : 'http:',
            postfix = container.stage ? 'stage/' : '/',
            acct =
              void 0 !== container.account ? container.account.split('') : [],
            spid = '',
            j = 0;
          for (i = 0; i < acct.length; i++)
            i >= 2
              ? (j++,
                2 === j
                  ? ((j = 0),
                    (spid += i !== acct.length - 1 ? acct[i] + '/' : acct[i]))
                  : (spid += acct[i]))
              : (spid += acct[i]);
          return (
            protocol +
            '//content.atomz.com/autocomplete/' +
            spid +
            postfix +
            '?' +
            (container.maxResults ? 'count=' + container.maxResults : '')
          );
        },
        isMatch: function (container, content, term) {
          var matcher = null,
            matchcase = container.queryCaseSensitive ? '' : 'i';
          return (
            (matcher =
              container.matchType && 'start' === container.matchType
                ? new RegExp('^' + term, matchcase)
                : container.matchType && 'phrase' === container.matchType
                  ? new RegExp('^(?!' + term + ')', matchcase)
                  : new RegExp(term, matchcase)) && matcher.test(content)
          );
        },
        highlightHtml: function (html, term) {
          var terms = term.split(/\s/);
          if (
            ((terms = terms.length ? terms : []),
            terms.length || terms.push(term),
            terms.length)
          ) {
            var elem = $(html);
            return (
              $(terms).each(function (i, val) {
                val.match(/\w/) &&
                  elem.find('.sayt-list-element').each(function () {
                    var els = $(this).find('*');
                    els.length !== 0
                      ? $(els).highlight(val, 'sayt-match')
                      : $(this).highlight(val, 'sayt-match');
                  });
              }),
              elem.html() ? elem.html() : ''
            );
          }
          return html;
        },
        open: function () {
          var o = this,
            func = function () {};
          o.options.fade
            ? o.viewElement.animate(
                {
                  opacity: '1',
                },
                o.options.secondsToOpen,
              )
            : !o.options.fade && o.options.secondsToOpen
              ? ((func = o.options.displayTypeOpen
                  ? function () {
                      o.viewElement.css(o.options.displayTypeOpen);
                    }
                  : function () {
                      o.viewElement.show();
                    }),
                setTimeout(func, o.options.secondsToOpen))
              : o.viewElement.show(),
            o.adjustWidth(),
            o.adjustHeight();
        },
        close: function () {
          var o = this,
            func = function () {};
          o.options.fade
            ? o.viewElement.animate(
                {
                  opacity: '0',
                },
                o.options.secondsToClose,
              )
            : !this.options.fade && o.options.secondsToClose
              ? ((func = o.options.displayCSSHide
                  ? function () {
                      o.viewElement.css(o.options.displayCSSHide);
                    }
                  : function () {
                      o.viewElement.hide();
                    }),
                setTimeout(func, o.options.secondsToClose))
              : (func = o.options.displayCSSHide
                  ? function () {
                      o.viewElement.css(o.options.displayCSSHide);
                    }
                  : function () {
                      o.viewElement.hide();
                    })();
        },
        adjustWidth: function () {
          var o = this,
            maxWidth = 0,
            allowed = !0;
          null !== o.options.minWidth &&
            ('function' == typeof o.options.onAdjustWidth &&
              (allowed = o.options.onAdjustWidth()),
            allowed
              ? -1 === o.options.minWidth
                ? (o.options.adjustWidthChildren.length &&
                    $(o.options.adjustWidthChildren).each(function (i, str) {
                      o.setWidth(str, 'auto');
                    }),
                  o.viewElement.find('.sayt-container').each(function () {
                    $(this).height() > maxWidth &&
                      (maxWidth = $(this).height());
                  }),
                  o.setWidth(o.viewElement, width),
                  o.options.adjustWidthChildren.length &&
                    $(o.options.adjustWidthChildren).each(function (i, str) {
                      o.setWidth(str, width);
                    }))
                : o.options.minWidth > -1 &&
                  allowed &&
                  o.setWidth(o.viewElement, o.options.minWidth)
              : (o.viewElement.css(o.options.defaultCSSWidth),
                o.options.adjustWidthChildren.length &&
                  $(o.options.adjustWidthChildren).each(function (i, str) {
                    o.setWidth(str, o.options.defaultCSSWidth);
                  })));
        },
        adjustRowHeight: function (cells) {
          var maxHeight = 0;
          return (
            $(cells).each(function () {
              $(this).height() > maxHeight && (maxHeight = $(this).height());
            }),
            maxHeight
          );
        },
        adjustHeight: function () {
          var o = this,
            allowed = !0,
            height = 0,
            cells = [],
            rows = 1,
            cols = 1;
          null !== o.options.minHeight
            ? ('function' == typeof o.options.onAdjustHeight &&
                (allowed = o.options.onAdjustHeight()),
              allowed &&
                (-1 === o.options.minHeight
                  ? (o.options.adjustHeightChildren.length &&
                      $(o.options.adjustHeightChildren).each(function (i, str) {
                        o.setHeight(str, 'auto');
                      }),
                    o.viewElement
                      .find('.sayt-container')
                      .each(function (i, obj) {
                        if (
                          rows <= o.options.layoutRows &&
                          cols === o.options.layoutColumns
                        ) {
                          cells.push(obj);
                          var h = o.adjustRowHeight(cells);
                          (height += h), (cols = 1), ++rows, (cells = []);
                        } else cells.push(obj), ++cols;
                        $(this).attr('data-sayt-row', rows),
                          $(this).attr('data-sayt-column', cols);
                      }),
                    1 !== o.options.layoutColumns &&
                      o.setHeight(o.viewElement, height),
                    o.options.adjustHeightChildren.length &&
                      $(o.options.adjustHeightChildren).each(function (i, str) {
                        o.setHeight(str, height);
                      }))
                  : o.options.minHeight > -1 &&
                    o.setHeight(o.viewElement, o.options.minHeight)))
            : (o.viewElement.css(o.options.defaultCSSHeight),
              o.options.adjustHeightChildren.length &&
                $(o.options.adjustHeightChildren).each(function (i, str) {
                  o.setHeight(str, o.options.defaultCSSHeight);
                }));
        },
        setWidth: function (elem, width) {
          var o = this;
          if ($(elem).length !== 0) {
            var unit = parseInt(width, 10) ? o.options.widthUnit : '';
            $(elem).css(
              o.options.useMinMax ? 'min-width' : 'width',
              width + unit,
            );
          }
        },
        setHeight: function (elem, height) {
          var o = this;
          if ($(elem).length !== 0) {
            var unit = parseInt(height, 10) ? o.options.heightUnit : '';
            $(elem).css(
              o.options.useMinMax ? 'min-height' : 'height',
              height + unit,
            );
          }
        },
        setActiveSelectionElement: function (down) {
          var size = 0,
            i = 0,
            sindex = $('.sayt-on').attr('data-sayt-index'),
            lindex = -1;
          $('.sayt-list-element').each(function () {
            var elem = this,
              even = i % 2 == 0,
              rowclass = 'sayt-even';
            even || (rowclass = 'sayt-odd'),
              $(elem).removeClass('sayt-odd'),
              $(elem).removeClass('sayt-even'),
              $(elem).attr('data-sayt-index', i),
              $(elem).addClass(rowclass),
              i++;
          }),
            (size = i),
            sindex
              ? ((sindex = parseInt(sindex, 10)), (lindex = sindex))
              : (sindex = -1),
            (sindex = down
              ? sindex + 1 < size
                ? sindex + 1
                : 0
              : sindex - 1 >= 0
                ? sindex - 1
                : size - 1),
            $(
              '.sayt-list-element[data-sayt-index="' + lindex + '"]',
            ).removeClass('sayt-on'),
            $('.sayt-list-element[data-sayt-index="' + sindex + '"]').addClass(
              'sayt-on',
            );
        },
        scrollUp: function () {
          this.options.arrowKeys && this.setActiveSelectionElement(!1),
            this.open();
        },
        scrollDown: function () {
          this.options.arrowKeys && this.setActiveSelectionElement(!0),
            this.open();
        },
        go: function () {
          var o = this,
            frm = o.getFormElement(),
            size = $('.sayt-on').find('.sayt-link').length;
          if (
            (o.options.disableOnSubmit &&
              (frm.onsubmit = function () {
                return !1;
              }),
            size)
          ) {
            var href = $('.sayt-on').find('.sayt-link').attr('href');
            'function' == typeof o.options.onSelect &&
              o.options.onSelect(frm, newval, href),
              o.options.submitOnSelect && href && (w.location = href);
          } else if ($('.sayt-on').length !== 0) {
            var newval = $('.sayt-on').attr('data-sayt-value');
            newval && o.inputElement.val(newval),
              'function' == typeof o.options.onSelect &&
                o.options.onSelect(frm, newval, ''),
              o.options.submitOnSelect && frm.submit();
          }
        },
      }),
      ($.fn[pluginName] = function (options) {
        var plugin = this.data(dataKey);
        return (
          plugin instanceof TargetPlugin
            ? void 0 !== options && plugin.init(options)
            : ((plugin = new TargetPlugin(this, options)),
              this.data(dataKey, plugin)),
          plugin
        );
      });
  })($, window, document);
var targetsettings = {
  minInputLength: 1,
  emptyInputValue: 'Search',
  minInputDelay: 50,
  useMinMax: !1,
  adjustHeightOnResize: !0,
  resizeThrottle: 70,
  minWidth: 400,
  minHeight: -1,
  submitOnSelect: !1,
  layoutRows: 1,
  layoutColumns: 2,
  defaultCSSWidth: {
    width: 'auto',
  },
  defaultCSSHeight: {
    height: 'auto',
  },
  adjustHeightChildren: ['#sayt-list', '.sayt-list'],
  adjustWidthChildren: [''],
  onAdjustHeight: function (t, e) {
    return (
      $('#sayt-links').length !== 0 &&
        '2000px' === $('#sayt-links').css('max-width') &&
        ($('#sayt-list').css('height', 'inherit'),
        $('.sayt-list').css('height', 'inherit')),
      $('#sayt-links').length !== 0 &&
        '2000px' !== $('#sayt-links').css('max-width')
    );
  },
  onSelect: function (t, e, i) {
    function s() {
      window.location.href =
        '/Search/?term=' + document.getElementById('search-field').value;
    }

    i ? (window.location.href = i) : e && s();
  },
  containers: [
    {
      account: '',
      maxResults: 5,
      containerType: 'autocomplete',
      highlightWords: !0,
      className: '',
      id: 'sayt-keywords',
      matchType: 'mixed',
      minWidth: -1,
      minHeight: -1,
    },
    {
      requestUrl: '',
      className: '',
      id: 'sayt-links',
      ajaxDataType: 'script',
      containerType: 'WSCS',
      appendToQuery: '*',
      highlightWords: !0,
      queryParam: 'q',
      minWidth: -1,
      minHeight: -1,
    },
  ],
  getSettings: function () {
    return $.ajax({
      type: 'POST',
      url: '/webmethods.aspx/getsearchurl',
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      context: this,
      success: function (response) {
        var data = response.d;
        //   accountID = data.split("//")[1].split(".")[0];
        // (this.containers[0].account = accountID), -1 === data.indexOf("?") ? (this.containers[1].requestUrl = data + "?do=sayt2") : (this.containers[1].requestUrl = data + "&do=sayt2");
      },
      failure: function (response) {
        console.warn('Failed to load Adobe S&P url');
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.warn('Failed to load Adobe S&P url');
      },
    });
  },
};

function BindSearch(cb, querystring, category, selectedlabel, selectedlabels) {
  BindSearchResults(
    querystring,
    category,
    selectedlabel,
    cb.checked,
    selectedlabels,
  );
}

function BindSearchCategory(querystring, category) {
  BindSearchResults(querystring, category, '', 'false', '');
}

function BindSearchResults(
  querystring,
  category,
  selectedlabel,
  selectedValue,
  selectedlabels,
) {
  $('searchresultmain').html(''),
    $('.breadcrumb').hide(),
    $.ajax({
      type: 'POST',
      url: '/webmethods.aspx/searchbindv2',
      data: JSON.stringify({
        fullquerystring: querystring,
        category: category,
        selectedlabel: selectedlabel,
        selectedValue: selectedValue,
        selectedlabels: selectedlabels,
      }),
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success: function (response) {
        try {
          var text = response.d;
          $('#searchresultmain').html(text),
            typeof iFrameResize !== 'undefined' &&
              iFrameResize({
                checkOrigin: !1,
                warningTimeout: 0,
                heightCalculationMethod: 'lowestElement',
              }),
            0 === $('.search-filters .list-wrapper li').length
              ? switchNoFilters()
              : switchToFilters(),
            $('.floating-filter').on('click', showFilterModal),
            $('.modal-filter .filter-list').on(
              'click',
              selectFilterOfModalFilter,
            ),
            $('.modal-filter .actions .apply').on(
              'click',
              doneFilterOfModalFilter,
            ),
            $('.modal-filter .actions .cancel').on(
              'click',
              clearAndResetFilters,
            );

          var page, queryarray;
          'Unknown' === category
            ? (history.pushState('', '', querystring), clearFilters())
            : '' !== category
              ? ((queryarray = querystring.split(';')),
                $(queryarray).each(function () {
                  this.indexOf('page=') || (page = this.split('=')[1]);
                }),
                page
                  ? SetPushState({
                      q: getParameterByName('q'),
                      page: page,
                      category: category,
                    })
                  : SetPushState({
                      q: getParameterByName('q'),
                      category: category,
                    }),
                onSearchCompleteEvents(category))
              : ((queryarray = querystring.split(';')),
                $(queryarray).each(function () {
                  this.indexOf('page=') || (page = this.split('=')[1]);
                }),
                page &&
                  SetPushState({
                    q: getParameterByName('q'),
                    page: page,
                  })),
            $('html, body').animate(
              {
                scrollTop: 0,
              },
              0,
            );
        } catch (ex) {}
      },
      failure: function (response) {
        alert(response);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        var errMessage =
          'An error occured serving your request. Please try again.';
        jqXHR && (errMessage = $.parseJSON(jqXHR.responseText).Message),
          alert(errMessage);
      },
    });
}

function switchNoFilters() {
  $('.section.search-results').addClass('no-filters'),
    $('.floating-filter').addClass('no-filters');
}

function switchToFilters() {
  $('.section.search-results').removeClass('no-filters'),
    $('.floating-filter').removeClass('no-filters');
}

function onSearchCompleteEvents(category) {
  $('[data-filter="' + category + '"]')
    .parent()
    .addClass('active'),
    $('.apply, .cancel').addClass('active'),
    $('.apply, .cancel').prop('disabled', !1),
    $('.reset').addClass('active'),
    0 === $('.filtered-by').length &&
      $('.filters-trigger').prepend(
        '<div class="filtered-by">\n    <div class="filter-tag">\n      <span>Category</span>\n      <a class="remove-filter" href="#"><img src="/img/svg/close-grey.svg" /></a>\n    </div>\n</div>',
      ),
    $('.filter-tag').children('span').text(category),
    $('.filter-tag').css('display', 'inline-block'),
    $(document).on('click', '.filters-trigger .label', function () {
      $(this).parent().next().toggleClass('active');
    }),
    $('.reset').length > 0 &&
      ($(document).on('click', '.reset.active', function (e) {
        clearFilters(e);
      }),
      $(document).on('click', '.remove-filter', function (e) {
        BindSearchResults(
          '?term=' + getParameterByName('q'),
          'Unknown',
          '',
          'false',
          '',
        ),
          clearFilters(e);
      }),
      $window.width() < 1025
        ? $('.search-filters-container').hasClass('collapsed') ||
          $('.search-filters-container').addClass('collapsed')
        : $(document).off(
            'click',
            '.search-filters-container.collapsed .title',
          ),
      $(document).on(
        'click',
        '.search-filters-container.collapsed .title',
        function (e) {
          $('.search-filter-set').toggleClass('active');
        },
      )),
    $('.search-results').length > 0 &&
      $window.width() < 1025 &&
      $('.filter-set').each(function () {
        $(this).children('h5').hasClass('active') &&
          ($(this).children('h5').addClass('active'),
          $(this).children('.filters').removeClass('active'));
      }),
    $('.search-filter-set').length > 0 &&
      $('.trigger-icon').on('click', function (e) {
        e.stopPropagation(),
          $(this).parent().hasClass('active') ||
            ($('.trigger-icon').parent().removeClass('active'),
            $(this).parent().addClass('active'),
            $('.reset').addClass('active'),
            $('.apply, .cancel').addClass('active'),
            $('.apply, .cancel').prop('disabled', !1));
      }),
    $('.checked-filters').length > 0 && moveCheckedFilters(),
    $('.checked-filters').length > 0 &&
      $('.checked-filters').on('click', 'li', filterCheck);
}

function showFilterModal(e) {
  e.stopPropagation(),
    $('.modal-filter').fadeIn(),
    $('.modal-filter').addClass('active'),
    $('.floating-filter').addClass('active');
}

function hideFilterModal() {
  $('.modal-filter').fadeOut(),
    $('.modal-filter').removeClass('active'),
    $('.floating-filter').removeClass('active');
}

function clearAndResetFilters() {
  clearFilterOfModalFilter();
  var q = getParameterByName('q');
  history.pushState('', '', '?'),
    BindSearchResults('?term=' + q, 'Unknown', '', 'false', ''),
    clearFilters(e);
}

function clearFilterOfModalFilter() {
  $('.filter-trigger.active').length > 0 &&
    $('.filter-trigger.active').removeClass('active'),
    $('.filter-tag').css('display', 'none'),
    $('.reset').removeClass('active'),
    $('.apply, .cancel').removeClass('active'),
    $('.apply, .cancel').prop('disabled', !0);
}

function selectFilterOfModalFilter(e) {
  clearFilterOfModalFilter(),
    $(e.target).parents('.filter-trigger').addClass('active'),
    $('.apply, .cancel').addClass('active'),
    $('.apply, .cancel').prop('disabled', !1),
    $('.reset').addClass('active');
}

function doneFilterOfModalFilter() {
  var q = getParameterByName('q'),
    selected = $('.filter-trigger.active').children().data('filter');
  BindSearchCategory('?i=1;q=' + q + ';x1=page_type;q1=' + selected, selected),
    hideFilterModal(),
    $('.apply, .cancel').prop('disabled', !1);
}

$(document).ready(function () {
  if ($('#search-field').length >= 1) {
    var searchstring = getParameterByName('q'),
      category = getParameterByName('category'),
      page = getParameterByName('page');
    null !== searchstring &&
      (BindSearchResults(
        '?i=1;q=' +
          searchstring +
          (category ? ';x1=page_type;q1=' + category : '') +
          (page ? ';rank=RANK;page=' + page : ''),
        category || '',
        '',
        'false',
        '',
      ),
      (document.getElementById('search-field').value = searchstring));
  }
});

function initialEllipsis() {
  var check_count = 0,
    first_element = $('.content-hub .tab-container .content .stories').find(
      "[data-story='1']",
    ),
    text_data = [];
  if (first_element.length > 0) {
    $('.content-hub .tab-container .content .stories .story').each(function () {
      var original_text = $(this).find('.description span').text();
      text_data.push(original_text);
    });
    var original_scrollHeight =
        first_element.find('.description span')[0].scrollHeight,
      checking = setInterval(function () {
        check_count++;
        var display_scrollHeight =
          first_element.find('.description span')[0].scrollHeight;
        (check_count <= 4 || display_scrollHeight != original_scrollHeight) &&
          (addEllipsis(first_element), clearInterval(checking));
      }, 100);
    original_texts = text_data;
  }
}

function resizeEllipsis() {
  var check_count = 0,
    story = $('.content-hub .tabs li.active').find('a').data('story'),
    element = $('.content-hub .tab-container .content .stories').find(
      "[data-story='" + story + "']",
    );
  element.length > 0 &&
    $('.content-hub .tab-container .content .stories .story').each(
      function (index, value) {
        $(this).removeAttr('data-checked');
        var position = parseInt($(this).data('story')) - 1;
        if (
          ($(this).find('.description span').text(original_texts[position]),
          index >=
            $('.content-hub .tab-container .content .stories .story').length -
              1)
        )
          var original_scrollHeight =
              element.find('.description span')[0].scrollHeight,
            checking = setInterval(function () {
              check_count++;
              var display_scrollHeight =
                element.find('.description span')[0].scrollHeight;
              (check_count <= 4 ||
                display_scrollHeight != original_scrollHeight) &&
                (addEllipsis(element), clearInterval(checking));
            }, 100);
      },
    );
}

function addEllipsis(element) {
  if(element.length === 0) return;
  var element_to_check = $(element).find('.description span');
  var url = $(element_to_check).data('url');
  var read_text = $(element_to_check).data('read');
  var ellipsis = isEllipsisActive(element_to_check[0]);

  $.fn.renderedText = function () {
    var o;
    var s;
    o = s = this.text();
    while (s.length && this[0].scrollHeight > this.innerHeight()) {
      s = s.slice(0, -1);
      this.text(s + '…');
    }
    this.text(o);
    return s;
  };

  function isEllipsisActive(ellipsisElement) {
    var tolerance = 2; // In px. Depends on the font you are using
    return ellipsisElement.offsetHeight + tolerance < ellipsisElement.scrollHeight;
  }

  var checked = $(element).data('checked');
  if (!checked) {
    $(element).attr('data-checked', 'true');
    var rendered_text = $(element_to_check).renderedText();
    var short_text;
    if (ellipsis) {
      short_text = rendered_text.slice(0, -20);
      short_text =
        short_text +
        ('...<a href="' + url + '" class="read-more newintextbutton">' + read_text + '</a>');
    } else {
      short_text =
        rendered_text +
        ('<a href="' + url + '" class="read-more newintextbutton">' + read_text + '</a>');
    }
    $(element_to_check[0]).html('');
    $(element_to_check[0]).html(short_text);
    $(element).find('.story-content').css('opacity', '1');
  }
}

function orderSlider(mobile) {
  var slides = $('.content-hub .tab-container .content .stories .story').length;
  for (slides; slides > 1; slides--) {
    var prev_slide = slides - 1;
    $(".stories .story[data-story='" + slides + "']").insertAfter(
      ".stories .story[data-story='" + prev_slide + "']",
    ),
      2 === slides && mobile && createSlider();
    $('.story').removeClass('active');
    $('.story:nth-child(2)').addClass('active');
  }
}

function createSlider() {
  var slider = $('.content-hub .tab-container .content .stories');
  $('.stories .story:last').insertBefore('.stories .story:first'),
    slider.css('margin-left', '-70%'),
    $('.content-hub .stories .story').removeClass('active'),
    $('.content-hub .stories .story').css('display', 'block'),
    slider.find("[data-story='1']").addClass('active'),
    slider.find("[data-story='1']").find('.story-content').css('opacity', 1),
    $('.content-hub .tab-system .mobile-bullets div:nth-child(1)').addClass(
      'active',
    ),
    slider.find('.story').each(function () {
      1 !== $(this).data('story') && addEllipsis($(this));
    });
  $('.story').removeClass('active');
  $('.story:nth-child(2)').addClass('active');
}

function setHeaderHeight() {
  /* var header = setInterval(function() {
        if ($(".story-content .featured-media figure img").height() > 80) {
            var intro_height = $(".story-content .section-intro").height(),
                image_height = $(".story-content .featured-media figure img").height();
            header_height = intro_height + image_height;
            var margins = $(window).width() < 450 ? 20 : 60,
                margin_top = intro_height + image_height / 2 + margins;
            header_height < 400 && $(window).width() > 600 && ((header_height = 400), (margin_top = 320)), $(window).width(), $(".main-content.story-content").css("margin-top", -1 * margin_top), clearInterval(header);
     }
    }, 100);*/
}

$('.content-hub .tabs li').on('click', function (event) {
  var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints,
    story = $(this).find('a').data('story');
  if (supportsTouch && story) return !1;
  var that = this,
    init_story = $('.content-hub .tabs li.active').find('a').data('story');
  !$(this).hasClass('active') &&
    story &&
    ($('.content-hub .tab-container .content .stories')
      .find("[data-story='" + init_story + "']")
      .fadeOut(),
    $('.content-hub.tabs li.active').removeClass('active'),
    $(that).addClass('active'),
    $('.content-hub .tab-container .content .stories')
      .find("[data-story='" + story + "']")
      .fadeIn(),
    addEllipsis(
      $('.content-hub .tab-container .content .stories').find(
        "[data-story='" + story + "']",
      ),
    ));
});
var elapsed_time,
  init_story = 1;
$('.content-hub .tabs li').hover(
  function () {
    var that = this,
      story = $(this).find('a').data('story');
    elapsed_time = setTimeout(function () {
      !$(this).hasClass('active') &&
        story &&
        ($('.content-hub .tab-container .content .stories')
          .find("[data-story='" + init_story + "']")
          .fadeOut('fast'),
        $('.content-hub .tabs li.active').removeClass('active'),
        $(that).addClass('active'),
        $('.content-hub .tab-container .content .stories')
          .find("[data-story='" + story + "']")
          .fadeIn('fast'),
        addEllipsis(
          $('.content-hub .tab-container .content .stories').find(
            "[data-story='" + story + "']",
          ),
        ),
        (init_story = story));
    }, 200);
  },
  function () {
    clearInterval(elapsed_time);
  },
);

(function ($) {
  $(() => {
    const $tabsContainer = $('.content-hub .tab-container');
    const story = $tabsContainer.find('.tabs li.active a').data('story');
    const textElement = $tabsContainer.find(
      `.content .stories [data-story="${story}"]`,
    );
    if (!textElement) return;
    addEllipsis(textElement);
  });
})(jQuery);

var original_texts;
!(function ($) {
  $.fn.swipeDetector = function (options) {
    function swipeStart(event) {
      (options.useOnlyTouch && !event.originalEvent.touches) ||
        (event.originalEvent.touches &&
          (event = event.originalEvent.touches[0]),
        0 === swipeState &&
          ((swipeState = 1),
          (startX = event.clientX),
          (startY = event.clientY)));
    }

    function swipeEnd(event) {
      //(options.useOnlyTouch && !event.originalEvent.touches) || (event.originalEvent.touches && (event = event.originalEvent.touches[0]), 0 === swipeState && ((swipeState = 1), (startX = event.clientX), (startY = event.clientY)));
      2 === swipeState &&
        ((swipeState = 0),
        Math.abs(pixelOffsetX) > Math.abs(pixelOffsetY) &&
        Math.abs(pixelOffsetX) > options.swipeThreshold
          ? pixelOffsetX < 0
            ? swipeTarget.trigger($.Event('swipeLeft.sd'))
            : swipeTarget.trigger($.Event('swipeRight.sd'))
          : Math.abs(pixelOffsetY) > options.swipeThreshold &&
            (pixelOffsetY < 0
              ? swipeTarget.trigger($.Event('swipeUp.sd'))
              : swipeTarget.trigger($.Event('swipeDown.sd'))));
    }

    function swiping(event) {
      if (event.type == 'touchmove') {
        if (1 === swipeState) {
          event.originalEvent.touches &&
            (event = event.originalEvent.touches[0]);
          var swipeOffsetX = event.clientX - startX,
            swipeOffsetY = event.clientY - startY;
          (Math.abs(swipeOffsetX) > options.swipeThreshold ||
            Math.abs(swipeOffsetY) > options.swipeThreshold) &&
            ((swipeState = 2),
            (pixelOffsetX = swipeOffsetX),
            (pixelOffsetY = swipeOffsetY));
        }
      }
    }

    var swipeState = 0,
      startX = 0,
      startY = 0,
      pixelOffsetX = 0,
      pixelOffsetY = 0,
      swipeTarget = this,
      defaultSettings = {
        swipeThreshold: 70,
        useOnlyTouch: !0,
      };
    return (
      (function () {
        (options = $.extend(defaultSettings, options)),
          swipeTarget.on('mousedown touchstart', swipeStart),
          $('html').on('mouseup touchend', swipeEnd),
          $('html').on('mousemove touchmove', swiping);
      })(),
      swipeTarget
    );
    $('.story').removeClass('active');
    $('.story:nth-child(2)').addClass('active');
  };
})(jQuery),
    $('document').ready(function () {
        setTimeout(function () {
            // sets height for slider on /our-stories/ to prevent text overlap with longer text
            $('#OurStoriesLeftNav').find('a').each(function () {
                if (window.innerWidth < 1025 && window.innerWidth > 766) {
                    if ($(this).find('.category').height() > 21) {
                        $(this).find('.arrow').addClass('cropped')
                    }
                }
                else {
                    $(this).find('.arrow').removeClass('cropped');
                }
            });
        }, 1001);
    function moveR() {
      slider.animate(
        {
          marginLeft: '-140%',
        },
        200,
        function () {
          $('.stories .story:first').insertAfter('.stories .story:last'),
            slider.css('margin-left', '-70%');
        },
      ),
        (position += 1),
        position > 5 && (position = 1),
        $('.stories .story').removeClass('active'),
        $('.content-hub .tab-system .mobile-bullets div').removeClass('active'),
        $('.stories .story .story-content').removeAttr('style'),
        slider.find("[data-story='" + position + "']").addClass('active'),
        slider
          .find("[data-story='" + position + "']")
          .find('.story-content')
          .css('opacity', 1),
        $(
          '.content-hub .tab-system .mobile-bullets div:nth-child(' +
            position +
            ')',
        ).addClass('active');
      $('.story').removeClass('active');
      $('.story:nth-child(3)').addClass('active');
    }

    function moveL() {
      slider.animate(
        {
          marginLeft: 0,
        },
        200,
        function () {
          $('.stories .story:last').insertBefore('.stories .story:first'),
            slider.css('margin-left', '-70%');
        },
      ),
        (position -= 1),
        position < 1 && (position = 5),
        $('.stories .story').removeClass('active'),
        $('.content-hub .tab-system .mobile-bullets div').removeClass('active'),
        $('.stories .story .story-content').removeAttr('style'),
        slider.find("[data-story='" + position + "']").addClass('active'),
        slider
          .find("[data-story='" + position + "']")
          .find('.story-content')
          .css('opacity', 1),
        $(
          '.content-hub .tab-system .mobile-bullets div:nth-child(' +
            position +
            ')',
        ).addClass('active');
      $('.story').removeClass('active');
      $('.story:nth-child(1)').addClass('active');
    }

    $('.stories')
      .swipeDetector()
      .on(
        'swipeLeft.sd swipeRight.sd swipeUp.sd swipeDown.sd',
        function (event) {
          event.stopPropagation(),
            'swipeLeft' === event.type
              ? moveR()
              : 'swipeRight' === event.type
                ? moveL()
                : 'swipeUp' === event.type || event.type;
        },
      );
    var slider = $('.content-hub .tab-container .content .stories'),
      position = 1;
    $(window).width() < 667 && slider.length > 0 && createSlider();
  }),
  $('.stories .story a').on('click', function (event) {
    $(window).width() < 667 &&
      !$(this).parent().hasClass('active') &&
      event.preventDefault();
  });

if ($('.social-footer').length) {
  var called = !1,
    element_position = $('.social-footer').offset().top - 200;
  $(window).on('scroll', function () {
    if ($('.backbox').hasClass('floating')) {
      window.pageYOffset > element_position
        ? $('.backbox').fadeOut(100)
        : $('.backbox').fadeIn(100);
    }
  });
}
$(window).on('resize', function () {
  $('.our-stories-header').length > 0 && setHeaderHeight(),
    setTimeout(function () {
      $(window).width() > 667 &&
        $('.content-hub .stories').length > 0 &&
        (orderSlider(),
        $('.our-stories .stories').removeAttr('style'),
        $('.our-stories .stories .story').removeAttr('data-checked'));
      if (window.innerWidth < 667) {
        $('.open-html.stories').css('margin-left', '-70%');
      } else {
        $('.open-html.stories').removeAttr('style');
        var result = $('div.story').sort(function (a, b) {
          var contentA = parseInt($(a).data('story'));
          var contentB = parseInt($(b).data('story'));
          return contentA < contentB ? -1 : contentA > contentB ? 1 : 0;
        });

        $('.open-html.stories').html(result);
      }
    }, 300);
}),
  $(document).on(
    'click',
    '.our-stories-article, .content-hub .segment.has-image',
    function () {
      var article = $(this).find('a').attr('href');
      window.open(article, '_self');
    },
  );

$(document).ready(function () {
  //$('.arrow.last').text($('.arrow.last').text().slice(0, -1));  affects /our-stories/ 
  $('.button.secondary').find('span').removeAttr('style');
  $('.button.secondary.PB').removeAttr('style');
  $('#PharmaceuticalDistribution')
    .parent()
    .click(function () {
      if ($('#browse-results').find('.results').css('padding-top') == '0px') {
        $('#browse-results').find('.results').removeAttr('style');
      } else {
        $('#browse-results').find('.results').css('padding-top', '0px');
      }
      $('#PharmaceuticalDistribution')
        .parent()
        .parent()
        .toggleClass('MenuFirstItem');
    });
  $('h6:contains("VIDEO")').addClass('VideoEyebrow');
  setTimeout(function () {
    var maxHeight = 0;
    $('.article.twitter')
      .each(function () {
        maxHeight = $(this).height() > maxHeight ? $(this).height() : maxHeight;
      })
      .height(maxHeight);
  }, 1000);
  if ($('.header.hero').length > 0) {
    if ($('.gateway').length == 0) {
      $('.header').removeClass('hero');
      $('.header').addClass('clearhero');
    }
  }
  $('.RelatedSolutions').find('.more').removeAttr('style');
  $('.button.secondary').find('span').removeAttr('style');
  $('.section.segments.skyblueBG')
    .find('.button.secondary span')
    .removeAttr('style');
  $('.button.secondary.PB').find('span').removeAttr('style');
  if ($('body.specialty').length == 1) {
    var classList = $('body').attr('class');
    var classArr = classList.split(/\s+/);
    if (classArr.length == 2) {
      $('.header').addClass('hero');
    }
  }
  //if($('#bodyId').attr("class").indexOf('gateway')>0)
  //{
  //   // $('.PD').removeClass('PD');
  //   // $('.PB').removeClass('PB');
  //}
  $('.gateway')
    .find('.PromoPrimary.ltr')
    .each(function () {
      if ($('.homePage') != 1)
        $(this).find('span.image').addClass('MakeRightSideRoundeEqualInMiddle');
    });
  $('.gateway')
    .find('.PromoPrimary.rtl')
    .each(function () {
      if ($('.homePage') != 1)
        $(this).find('span.image').addClass('MakeLeftSideRoundeEqualInMiddle');
    });
  $('.gateway')
    .find('.PromoPrimary.transparentBG')
    .each(function () {
      if ($('.homePage') != 1)
        $(this).find('span.image').addClass('MakeAllSidesRounded');
    });

  $('.gateway')
    .find('.promo-wrapper')
    .each(function () {
      const $promoWrapper = $(this);
      const $promoImage = $promoWrapper.find('img');
      const $innerWrapper = $promoWrapper.find('.wrapper');
      if ($('.homePage') != 1) {
        // if($(this).find('img').height()!=null)
        // {
        if ($promoImage.height() == $innerWrapper.height()) {
          $promoImage.addClass('imgequal');
          $innerWrapper.addClass('wrapperequal');
        }

        if ($promoImage.height() > $innerWrapper.height()) {
          $promoImage.addClass('imgtaller');
          $innerWrapper.addClass('wrappershorter');
          /* $(this).find('img').css('border-radius','10px');
            if($(this).parent().hasClass('ltr'))
            {
            $(this).find('.wrapper').find('.secondary-items').css('border-radius','10px 0px 0px  10px');
            $(this).find('.image-overlay').css('border-radius','10px 0px 0px  10px');
            }
            if($(this).parent().hasClass('rtl'))
            {
            $(this).find('.wrapper').find('.secondary-items').css('border-radius','0px 10px 10px  0px');
            $(this).find('.image-overlay').css('border-radius','0px 10px 10px  0px');
            }
            */
        } else {
          $innerWrapper.addClass('wrappertaller');
          $promoImage.addClass('imgshorter');

          /* $(this).find('.wrapper').css('border-radius','10px');
            if($(this).parent().hasClass('ltr'))
            {
             $(this).find('img').css('border-radius','0px 10px 10px  0px');
            }
            if($(this).parent().hasClass('rtl'))
            {
             $(this).find('img').css('border-radius','10px 0px 0px  10px');
            }*/
        }

        /*
          promo test Averlie 10 11
          if ($('.promo-wrapper:contains(".transparentBG ")')){
            $(this).find("img").addClass("TESTER");
            }*/

        //}
        $promoWrapper
          .find('.horizontal')
          .find('img')
          .css('border-radius', '10px');
        // console.log($(this).find('img').height());
        // console.log($(this).find('.wrapper').height());
      }
    });

  $('.content-hub')
  .find('.promo-wrapper')
  .each(function () {
    const $promoWrapper = $(this);
    const $promoImage = $promoWrapper.find('img');
    const $innerWrapper = $promoWrapper.find('.wrapper');
    if ($('.homePage') != 1) {
      // if($(this).find('img').height()!=null)
      // {
      if ($promoImage.height() == $innerWrapper.height()) {
        $promoImage.addClass('imgequal');
        $innerWrapper.addClass('wrapperequal');
      }
      if ($promoImage.height() > $innerWrapper.height()) {
        $promoImage.addClass('imgtaller');
        $innerWrapper.addClass('wrappershorter');
      } else {
        $innerWrapper.addClass('wrappertaller');
        $promoImage.addClass('imgshorter');
      }
      $promoWrapper
        .find('.horizontal')
        .find('img')
        .css('border-radius', '10px');
    }
  });


  if ($('body.our-stories').length == 1) {
    $('.button.read-more').find('span').removeAttr('style');
  }
  if ($('a').find('.content').find('img').length > 0) {
    $('.content').find('img').addClass('SLImgWrapper');
  }
  if ($('body.about-mckesson').length == 1) {
    var classList = $('body').attr('class');
    var classArr = classList.split(/\s+/);
    var index = classArr.indexOf('gateway');
    if (index !== -1) {
      classArr.splice(index, 1);
    }
    if (classArr.length == 2) {
      $('.ltr').find('.image').addClass('LEFT');
      setTimeout(function () {
        $('.section').find('.promo-wrapper').removeAttr('style');
      }, 1500);
    }
  }
  if ($('.backbox').length > 0) {
    $('.filters').removeClass('short');
  }
  if ($('.open-html.full').find('img').length > 0) {
    $('.open-html.full').find('img').removeAttr('style');
    //$('.open-html.full').find('img').addClass('OBSImg1');
  }
  if ($('.root.about-mckesson.our-businesses').length > 0) {
    $('.open-html.full').find('img').addClass('OBSImg1');
  }
  $('#mck-nav-modal').scroll(function () {
    if ($('.modal-content').offset().top < 150) {
      $('.link-tab.mbl').css('z-index', '-1');
      $('#trigger').css('z-index', '-1');
    } else {
      $('#trigger').css('z-index', '99999999999');
      $('.link-tab.mbl').css('z-index', '999999');
    }
  });

  $('#mck-nav-modal').scroll(function () {
    if ($('.modal-content').offset().top < 170) {
      $('#whitelogo').css('z-index', '-1');
      $('#search').css('z-index', '-1');
    } else {
      $('#whitelogo').css('z-index', '999999');
      $('#search').css('z-index', '999999');
    }
  });

  if ($('body.about-mckesson.newsroom').length == 1) {
    $('.view-all-wrapper').find('a').removeClass('button secondary');
    $('.view-all-wrapper').find('a').addClass('Button Secondary lightBG');
  }

  if ($('.customer-login').length > 0) {
    setTimeout(function () {
      var maxHeight = 0;
      $('.segment')
        .each(function () {
          maxHeight =
            $(this).height() > maxHeight ? $(this).height() : maxHeight;
        })
        .height(maxHeight);
    }, 1000);
  }
  if ($('body.biopharma.access-adherence').length == 1) {
    $('.PromoPrimary.ltr.navyBG').css('border-radius', '0px');
  }

  setTimeout(function () {
    // alert('2.5seconds');}, 2500);
    var config;
    $.getJSON('/jsonfeeds/getconfigjson.asmx/Getregextfields', function (data) {
      config = data.root.Item.find((o) => {
        return o['Label'] === 'Marketo_FormField_Allowed';
      }).Value; //data.root.Item[173].Value;//
      var regexthese = '[^a-z0-9' + config + ' ]';
      $('.mktoFormRow')
        .find('input')
        .on('input', function () {
          var c = this.selectionStart,
            r = new RegExp(regexthese, 'gi'),
            v = $(this).val();
          if (r.test(v)) {
            $(this).val(v.replace(r, ''));
            $(this).after(
              '<div class="mktoError" style="right: 133px; bottom: -45px;"><div class="mktoErrorArrowWrap"><div class="mktoErrorArrow"></div></div><div id="ValidMsgLastName" role="alert" tabindex="-1" class="mktoErrorMsg">' +
                data.root.Item.find((o) => {
                  return o['Label'] === 'Marketo_Disallowed_Message';
                }).Value +
                '</div></div>',
            );
            c--;
            setTimeout(function () {
              $('.mktoError').remove();
            }, 3000);
          } else {
            $('.mktoError').remove();
            this.setSelectionRange(c, c);
          }
        });
      localStorage.setItem('rinput', regexthese);
      config = data.root.Item.find((o) => {
        return o['Label'] === 'Marketo_FormField_Allowed';
      }).Value; //data.root.Item[174].Value;
      var regexthese = '[^a-z0-9' + config + ' ]';
      $('.mktoFormRow')
        .find('textarea')
        .on('input', function () {
          var c = this.selectionStart,
            r = new RegExp(regexthese, 'gi'),
            v = $(this).val();
          if (r.test(v)) {
            $(this).val(v.replace(r, ''));
            $(this).after(
              '<div class="mktoError" style="right: 133px; bottom: -45px;"><div class="mktoErrorArrowWrap"><div class="mktoErrorArrow"></div></div><div id="ValidMsgLastName" role="alert" tabindex="-1" class="mktoErrorMsg">' +
                data.root.Item.find((o) => {
                  return o['Label'] === 'Marketo_Disallowed_Message';
                }).Value +
                '</div></div>',
            );

            c--;
            setTimeout(function () {
              $('.mktoError').remove();
            }, 3000);
          } else {
            $('.mktoError').remove();
            this.setSelectionRange(c, c);
          }
        });
      localStorage.setItem('rtextarea', regexthese);
      localStorage.setItem(
        'rmessage',
        data.root.Item.find((o) => {
          return o['Label'] === 'Marketo_Disallowed_Message';
        }).Value,
      );
    });
    $('.mktoButton').on('click', function () {
      $('.mktoFormRow')
        .find('textarea')
        .each(function () {
          var c = this.selectionStart,
            r = new RegExp(localStorage.getItem('rtextarea'), 'gi'),
            v = $(this).val();
          if (r.test(v)) {
            $(this).val(v.replace(r, ''));
            $(this).after(
              '<div class="mktoError" style="right: 133px; bottom: -45px;"><div class="mktoErrorArrowWrap"><div class="mktoErrorArrow"></div></div><div id="ValidMsgLastName" role="alert" tabindex="-1" class="mktoErrorMsg">' +
                localStorage.getItem('rmessage') +
                '</div></div>',
            );

            c--;
          }
        });
    });

    $('.mktoFormRow')
      .find('input')
      .each(function (i, el) {
        let c = this.selectionStart;
        const reg = localStorage.getItem('rinput');
        let r = new RegExp(reg, 'gi');
        let v = $(this).val();
        if (r.test(v)) {
          $(this).val(v.replace(r, ''));
          c--;
        }
      });
  }, 2500);
  $('.promo-wrapper').removeAttr('style');
  $('.button.secondary').find('span').removeAttr('style');

  $('.button.secondary.inverted').removeAttr('style');

  $('.button.secondary').removeAttr('style');
  if ($('.open-html').find('a.button.secondary').find('span').length == 0) {
    $('.open-html').find('a.button.secondary').contents().wrap('<span></span>');
  }

  $('.gateway-section-back').removeAttr('style');
  if (window.innerWidth < 950) {
    if ($('body.contact-us').length == 1) {
      var maxHeight = 0;
      $('.page-tab')
        .each(function () {
          maxHeight =
            $(this).height() > maxHeight ? $(this).height() : maxHeight;
        })
        .height(maxHeight);
    }
    if ($('body.contact-us.support-contacts').length == 1) {
      var maxHeight = 0;
      $('.page-tab')
        .each(function () {
          maxHeight =
            $(this).height() > maxHeight ? $(this).height() : maxHeight;
        })
        .height(maxHeight);
    }
    if ($('body.contact-us.sales-contacts').length == 1) {
      var maxHeight = 0;
      $('.page-tab')
        .each(function () {
          maxHeight =
            $(this).height() > maxHeight ? $(this).height() : maxHeight;
        })
        .height(maxHeight);
    }
  }

  setTimeout(function () {
    $('.gateway-section-back').removeAttr('style');
    if (window.innerWidth < 1025) {
      $('#embeddedcomponent-105226701933')
        .find('.visual-copy.copy.navyBG.left')
        .removeAttr('style');
      $('#embeddedcomponent-105226701933')
        .find('.secondary-items.tealtintBG.horizontal')
        .removeAttr('style');
    }
    if (window.innerWidth < 950) {
      if ($('body.contact-us').length == 1) {
        var maxHeight = 0;
        $('.page-tab')
          .each(function () {
            maxHeight =
              $(this).height() > maxHeight ? $(this).height() : maxHeight;
          })
          .height(maxHeight);
      }
      if ($('body.contact-us.support-contacts').length == 1) {
        var maxHeight = 0;
        $('.page-tab')
          .each(function () {
            maxHeight =
              $(this).height() > maxHeight ? $(this).height() : maxHeight;
          })
          .height(maxHeight);
      }
      if ($('body.contact-us.sales-contacts').length == 1) {
        var maxHeight = 0;
        $('.page-tab')
          .each(function () {
            maxHeight =
              $(this).height() > maxHeight ? $(this).height() : maxHeight;
          })
          .height(maxHeight);
      }
    }

    $('.contact-segment')
      .find('.button.secondary')
      .find('span')
      .removeAttr('style');
    $('.contact-embedded')
      .find('.button.secondary')
      .find('span')
      .removeAttr('style');
  }, 1000);
  setTimeout(function () {
    $('a').each(function () {
      if ($(this).attr('href') != null) {
        if (
          !$(this).attr('href').startsWith('/') &&
          !$(this).attr('href').startsWith('mail') &&
          !$(this).attr('href').startsWith('javascript')
        ) {
          $(this).addClass('CTAExternal');
        }
        if ($(this).attr('href').indexOf('globalassets') >= 0) {
          $(this).addClass('CTAFile');
        }
      }
    });
    if (window.innerWidth >= 766 && window.innerWidth <= 836) {
      if ($('.homePage').length > 0) {
        // $('.promo-wrapper').removeAttr('style');
        $('#promoSpace').parent().parent().remove();
        $(
          '.section.visual-split:first-child .has-image .visual-image img',
        ).hide();
        $('.visual-copy').removeAttr('style');
      } else {
        $('.promo-wrapper').removeAttr('style');
      }
    }
  }, 1500);
  $(window).resize(function () {
    setTimeout(function () {
      $('#ExecLiwrapper').find('a').find('span').removeAttr('style');
      $('#ExecLiwrapper').find('a').removeAttr('style');
      $('.contact-segment')
        .find('.button.secondary')
        .find('span')
        .removeAttr('style');
      $('.contact-embedded')
        .find('.button.secondary')
        .find('span')
        .removeAttr('style');
      if (window.innerWidth < 1025) {
        $('#embeddedcomponent-105226701933')
          .find('.visual-copy.copy.navyBG.left')
          .removeAttr('style');
        $('#embeddedcomponent-105226701933')
          .find('.secondary-items.tealtintBG.horizontal')
          .removeAttr('style');
      }
      if (window.innerWidth >= 766 && window.innerWidth <= 836) {
        if ($('.homePage').length > 0) {
          // $('.promo-wrapper').removeAttr('style');
          $('#promoSpace').parent().parent().remove();
          $(
            '.section.visual-split:first-child .has-image .visual-image img',
          ).hide();
          $('.visual-copy').removeAttr('style');
        } else {
          $('.promo-wrapper').removeAttr('style');
        }
        }
    }, 750);
      setTimeout(function () {
          // sets height for slider on /our-stories/ to prevent text overlap with longer text
          $('#OurStoriesLeftNav').find('a').each(function () {
              if (window.innerWidth < 1025 && window.innerWidth > 766) {
                  if ($(this).find('.category').height() > 21) {
                      $(this).find('.arrow').addClass('cropped')
                  }
              }
              else {
                  $(this).find('.arrow').removeClass('cropped');
              }
          });
      }, 1001);
    if ($('.customer-login').length > 0) {
      var maxHeight = 0;
      $('.segment')
        .each(function () {
          maxHeight =
            $(this).height() > maxHeight ? $(this).height() : maxHeight;
        })
        .height(maxHeight);
    }
    if (window.innerWidth < 950) {
      if ($('body.contact-us').length == 1) {
        var maxHeight = 0;
        $('.page-tab')
          .each(function () {
            maxHeight =
              $(this).height() > maxHeight ? $(this).height() : maxHeight;
          })
          .height(maxHeight);
      }
      if ($('body.contact-us.support-contacts').length == 1) {
        var maxHeight = 0;
        $('.page-tab')
          .each(function () {
            maxHeight =
              $(this).height() > maxHeight ? $(this).height() : maxHeight;
          })
          .height(maxHeight);
      }
      if ($('body.contact-us.sales-contacts').length == 1) {
        var maxHeight = 0;
        $('.page-tab')
          .each(function () {
            maxHeight =
              $(this).height() > maxHeight ? $(this).height() : maxHeight;
          })
          .height(maxHeight);
      }
    }
    adjustPersonalizedHeroHeight();

    if (window.innerWidth >= 768 && window.innerWidth <= 1279) {
      setTimeout(function () {
        $('.promo-wrapper').removeAttr('style');
        if ($('span').css('background-image') == 'none') {
          $('span').removeAttr('style');
        }
        $('a').removeAttr('style');
      }, 1000);
    }
  });
  if ($('.hero.navyBG').length > 0) {
    $('.browse.active').css('background-color', '#007bc7');
  }
  $('.footer-section.first.odd ').find('nav').addClass('open');

  $('.root.careers')
    .find('.resources')
    .find('.resource')
    .find('.content')
    .find('div.brief')
    .removeClass('brief');
  $('.root.careers')
    .find('.resources')
    .find('.resource')
    .find('.content')
    .find('div')
    .addClass('whitecolor');
  $('.whitecolor').css('padding-top', '20px');

  if (
    $('.root.careers').find('.section.linen').find('.page-resource').length == 1
  ) {
    $('.root.careers')
      .find('.section.linen')
      .find('.page-resource')
      .find('a')
      .removeClass('PD');
    $('.root.careers')
      .find('.section.linen')
      .find('.page-resource')
      .find('a')
      .addClass('PB');
  }
  if (
    $('.root.careers').find('.section.linen').find('.page-resource').length == 0
  ) {
    $('.root.careers')
      .find('.section')
      .find('.page-resource')
      .find('a')
      .removeClass('PB');
    $('.root.careers')
      .find('.section')
      .find('.page-resource')
      .find('a')
      .addClass('PD');
  }
  if (window.innerWidth < 1024) {
    $('.root.our-stories')
      .find('.story')
      .click(function (e) {
        if (!$(this).hasClass('active')) {
          e.preventDefault();
        }
      });
  }
  $('#ExecLiwrapper').find('a').find('span').removeAttr('style');
  $('#ExecLiwrapper').find('a').removeAttr('style');
  if (window.location.pathname == '/') {
    if (window.innerWidth < 1025) {
      $('.visual-copy.copy.transparentBG.left').last().css('display', 'none');
    }

    setTimeout(function () {
      $('h2').show();
    }, 300);
  }
  $('.browse-tab.single').click(function () {
    if ($('#st-container').find('.section.no-padding.hero.navyBG').length > 0) {
      if ($(this).hasClass('navyactive')) {
        //$('.browse-tab.single').removeClass('navyactive');
        $(this).toggleClass('navyactive');
      } else {
        $('.browse-tab.single').removeClass('navyactive');
        $(this).toggleClass('navyactive');
      }
    }
  });
  $(document).click(function (event) {
    if (!$(event.target).closest('.browse-tab').length) {
      $('.browse-tab.single').removeClass('navyactive');
      $('#functions').removeClass('navyactive');
    }
  });

  $('#browse-tab0').click(function () {
    if ($('#st-container').find('.section.no-padding.hero.navyBG').length > 0) {
      setTimeout(function () {
        if ($('#browse-tab0').hasClass('browse-active')) {
          $('#functions').addClass('navyactive');
        } else {
          $('#functions').removeClass('navyactive');
        }
      }, 50);
    }
  });
  $('.has-submenu').click(function () {
    setTimeout(function () {
      if ($('.section.no-padding.hero.navyBG').length > 0) {
        $('#functions').addClass('navyactive');
      }
    }, 1);
  });

  $('.close-nav').click(function () {
    $('#functions').removeClass('navyactive');
  });
  $('.close-nav')
    .find('span')
    .click(function () {
      $('#functions').removeClass('navyactive');
    });

  $('#subscribewithcheckboxes').unbind('click');
  $('#subscribewithcheckboxes').click(function () {
    if ($("input[value='Blogs']").is(':checked')) {
      window.open(
        '/rss.aspx?type=' +
          $('.radios input:checked').val() +
          '&blogs=yes&blogid=' +
          $("input[value='Blogs']").attr('folderid'),
      );
    }
    if ($('.radios input:checked').val() == 'Events') {
      window.open('/rss.aspx?events=yes');
    } else {
      var taxparams = '';
      $('.taxcheckbox:checkbox:checked').each(function () {
        taxparams += $(this).val() + '_';
      });
      var ca = '';
      if ($('.radios input:checked').val() == 'ContentHubArchive') {
        ca = 'content-hub-archive';
      } else {
        ca = $('.radios input:checked').val();
      }
      window.open(
        '/rss.aspx?type=' +
          ca +
          '&business=' +
          taxparams.substring(0, taxparams.length - 1).replace('on_') +
          '&folderid=' +
          $('.radios input:checked').attr('folderid'),
      );
    }
  });
});

function togglesubboxes(checkbox) {
  if (checkbox.checked) {
    // $('.taxcheckbox').prop('checked', true);
    $(checkbox).parent().siblings().find('input').prop('checked', true);
  } else {
    $(checkbox).parent().siblings().find('input').prop('checked', false);
  }
}

function toggleradio(radio) {
  $('.taxcheckbox').prop('checked', false);
  $('.taxcheckboxall').prop('checked', false);
  if (
    $(radio).siblings('.taxonomycheckboxes').length == 1 &&
    radio.checked == true
  ) {
    $('.taxonomycheckboxes').hide();
    $(radio).siblings('.taxonomycheckboxes').show();
  } else {
    $('.taxonomycheckboxes').hide();
  }
}

// 2023 migration changes
function init() {
  const container = document.querySelector('.st-container');
  const buttons = Array.from(
    document.querySelectorAll('.js-st-trigger-effects'),
  );
  const eventtype = mobilecheck() ? 'touchstart' : 'click';
  const resetMenu = function () {
    $(container).removeClass('st-menu-open');
    $('.nav li.mbl .close-menu').removeClass('active');
    $('.nav li.mbl span.browse').removeClass('disabled');
  };

  $('.close-nav').click((e) => {
    e.preventDefault();
    resetMenu();
    document.removeEventListener(eventtype, bodyClickFn);
  });

  const bodyClickFn = function (evt) {
    if (!hasParentClass(evt.target, 'st-menu')) {
      resetMenu();
      document.removeEventListener(eventtype, bodyClickFn);
    }
    if (hasParentClass(evt.target, 'close-nav')) {
      resetMenu();
      document.removeEventListener(eventtype, bodyClickFn);
    }
  };

  buttons.forEach((button) => {
    button.addEventListener(eventtype, function (ev) {
      ev.stopPropagation();
      ev.preventDefault();
      $(container).removeClass('st-menu-open');
      $('.nav li.mbl .close-menu').addClass('active');
      $('.nav li.mbl span.browse').addClass('disabled');
      setTimeout(function () {
        $(container).addClass('st-menu-open');
      }, 25);
      document.addEventListener(eventtype, bodyClickFn);
    });
  });
}

init();

$('.trigger').on('click', (e) => {
  const modalId = e.currentTarget.dataset.target;
  const $body = $('body');
  if (modalId && !$body.hasClass('modal-opened')) {
    $(modalId).addClass('show');
    $body.addClass('modal-opened');
    $(window).on('click', (e) => {
      if ($(e.target).hasClass('show')) {
        $(modalId).removeClass('show');
        $body.removeClass('modal-opened');
      }
    });
  } else {
    $(modalId).removeClass('show');
    $body.removeClass('modal-opened');
  }
});

$('#mck-nav-modal').on('scroll', (e) => {
  const $elements = $(
    '.page-header .link-tab.mbl, .page-header .browse-tab.all > .trigger, .page-header .page-navbar-top',
  );
  if (e.currentTarget.scrollTop > 0) {
    $elements.css('z-index', 0);
  } else {
    $elements.css('z-index', 9999);
  }
});

const setBlocksHeight = ($blocks) => {
  $blocks.css('height', 'auto');
  $blocks.each((i, block) => {
    $(block)
      .find('div')
      .each((k, el) => {
        if (el.clientHeight > block.clientHeight) {
          $(block).css('height', el.clientHeight);
        }
      });
  });
};

const setPromoBlocksFullWidth = () => {
  Array.from(document.querySelectorAll('.promo-block')).forEach((el) => {
    if(el.clientWidth === document.body.clientWidth) {
        el.classList.add('promo-block--full');
        el.classList.add('promo-image-full-width');
        el.classList.remove('promo-image');
        el.classList.remove('promo-video');
    } else {
        el.classList.remove('promo-block--full');
        el.classList.remove('promo-image-full-width');
        if (el.classList.contains('has-video')){
          el.classList.add('promo-video');
        } else {
          el.classList.add('promo-image');
        }
    }
  })
}

const setOrRemoveRoundedCorners = () => {
    Array.from(document.querySelectorAll('.container .section, .content-group-block')).forEach((el) => {
        if (el.clientWidth === document.body.clientWidth) {
            // if full width, then remove rounded corners
            el.classList.remove('rounded-corners');
            el.classList.add('rectangular-corners');
        } else {
            el.classList.add('rounded-corners');
            el.classList.remove('rectangular-corners');
        }
    })
}

const handleSubmitRssForm = () => {
  $('.form-rss-feed-js [name="folderId"]').on('change', (e) => {
    const $dataHtml = $(e.currentTarget).parents('.form-rss-feed-js').find('.hidden-data-js');
    const selectedRadio = $(e.currentTarget);
    $dataHtml.find('[name="title"]').val(selectedRadio.data('title'));
    $dataHtml.find('[name="description"]').val(selectedRadio.data('description'));
    $dataHtml.find('[name="itemsMaxCount"]').val(selectedRadio.data('itemsMaxCount'));
  })
}

const hideBreadcrumbsIfHero = () => {
  const $hero = $('.mck-gateway-hero.hero');
  const $breadcrumbs = $('section.breadcrumb');
  if ($hero.length > 0 && document.querySelector('.breadcrumb').offsetTop === 0) {
    $breadcrumbs.css('height', '0');
  }
}

function removeTitleTips(){
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
        var link = links[i];
        link.onmouseover = function () {
            this.setAttribute("org_title", this.title);
            this.title = "";
        };
        link.onmouseout = function () {
            this.title = this.getAttribute("org_title");
        };
    }
}

function AddChangeTabEvents() {
    const $leftTab = $('#left-tab');
    if ($leftTab.attr("onClick") == undefined) {
        $leftTab.on('click', () => {
            changeTab("left");
        })
    }

    const $rightTab = $('#right-tab');
    if ($rightTab.attr("onClick") == undefined) {
        $rightTab.on('click', () => {
            changeTab("right");
        })
    }
}

$(() => {
    // document ready
    setBlocksHeight($('.stacked-promo-block'));
    setPromoBlocksFullWidth();
    setOrRemoveRoundedCorners();
    handleSubmitRssForm();
    hideBreadcrumbsIfHero();
    AddChangeTabEvents();
    setTimeout(function () {
        if (window.innerWidth < 958) {
            if ($("body.product-listing").length > 0) {
                $(".group").click(function () {
                    $(this).parent().find("ul").removeClass("Open");
                    $(this).children("ul").addClass("Open");
                });
            }
        }
     setalts();
    }, 250)
    setTimeout(function () {
        removeTitleTips();
    }, 500)

  $(window).resize(() => {
    // on window resize
    setBlocksHeight($('.stacked-promo-block'));
    setPromoBlocksFullWidth();
    setOrRemoveRoundedCorners();
  });
});

document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function (event) {
        var modal = document.getElementById("mck-nav-modal");    
        if (modal != null) {
            if (event.target !== modal && !modal.contains(event.target)) {
                var body = document.body;
                body.classList.remove("modal-opened");
            }
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        $(".section.segments.CardImage").find("figure").removeAttr("style");
    }, 500);
    var firstLi = document.querySelector(".list li:first-child");
    if (firstLi != null) {
        firstLi.classList.add("has-submenu", "active", "MenuFirstItem");

        var results = document.querySelector(".results");
        results.style.paddingTop = "0px";
    }
});
function setalts() {

    $('img').each(function () {
        var origalt = '';
        origalt = $(this).attr('alt');

        var alt = $(this).attr('src').substring($(this).attr('src').lastIndexOf('/') + 1, $(this).attr('src').lastIndexOf('.'));
        if (origalt == '' || origalt == null) {
            if (alt != '.com/') {
                $(this).attr('alt', alt);

            }
        }
    });

}
